(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77934],{

/***/ 80008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(85177);
moment.tz.load(__webpack_require__(91128));


/***/ }),

/***/ 85177:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.33
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if ( true && module.exports) {
		module.exports = factory(__webpack_require__(30381)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30381)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.33",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),

/***/ 37944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IB": function() { return /* reexport */ NavbarWeb; },
  "OI": function() { return /* reexport */ PopoverContainer; },
  "Bp": function() { return /* reexport */ PopoverCustom; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/@deprecated-ui/header/NavbarWeb.js
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-top: ",
        ";\n  box-sizing: border-box;\n  height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  max-height: 40px;\n  box-sizing: border-box;\n  padding: 0 0 0 10px;\n  overflow: hidden;\n  height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: auto;\n      opacity: 1;\n      padding: 10px 0;\n      visibility: visible;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 41px;\n  right: 10px;\n  height: 0px;\n  opacity: 0;\n  padding: 0;\n  visibility: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #dadada;\n  border-top: none;\n  transition: all 0.3s ease;\n\n  div:nth-child(-n + ",
        ") {\n    display: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-width: 0 1px;\n  border-color: ",
        ";\n  border-style: solid;\n  cursor: pointer;\n  position: relative;\n  right: 10px;\n\n  ::after {\n    content: '';\n    display: ",
        ";\n    width: 50px;\n    height: 1px;\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -1px;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var NavBarWebWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2b86138-0"
})(_templateObject(), function(param) {
    var minimize = param.minimize;
    return minimize ? 0 : "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro);
}, function(param) {
    var minimize = param.minimize;
    return minimize ? 0 : "auto";
});
var HorizontalNavigations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2b86138-1"
})(_templateObject1(), function(param) {
    var minimize = param.minimize;
    return minimize ? 0 : "auto";
});
var VerticalNavigations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2b86138-2"
})(_templateObject3(), function(props) {
    return props.elementToHide;
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});
var NavMoreLogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2b86138-3"
})(_templateObject4(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "#dadada" : "#ffffff";
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, color/* default.light */.Z.light);
var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b2b86138-4"
})(_templateObject5(), function(param) {
    var minimize = param.minimize;
    return minimize ? "none" : "block";
});
var NavMoreWrapper = function(param) {
    var Logo = param.Logo, children = param.children, minimize = param.minimize, elementToHide = param.elementToHide;
    var ref = (0,react.useState)(true), hideModal = ref[0], setModal = ref[1];
    var navMoreRef = (0,react.useRef)();
    var onNavMoreClick = function(e) {
        if (navMoreRef.current.contains(e.target)) {
            return setModal(!hideModal);
        }
        return setModal(true);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", onNavMoreClick);
        return function() {
            document.removeEventListener("click", onNavMoreClick);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Relative, {
        minimize: minimize,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreLogoWrapper, {
                ref: navMoreRef,
                isOpen: !hideModal,
                onClick: function(e) {
                    return onNavMoreClick(e);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavigations, {
                isOpen: !hideModal,
                elementToHide: elementToHide,
                children: children
            })
        ]
    });
};
var NavBarComponent = function(param) {
    var className = param.className, minimize = param.minimize, children = param.children, _expandNavLogo = param.expandNavLogo, expandNavLogo = _expandNavLogo === void 0 ? function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    } : _expandNavLogo;
    var ref = (0,react.useState)([]), moreNavElement = ref[0], setMoreNavElement = ref[1];
    var navHorizontalRef = (0,react.useRef)();
    var ExpandNavLogo = expandNavLogo;
    (0,react.useEffect)(function() {
        var updateNavigation = function() {
            var navigation = navHorizontalRef.current.children;
            var moreNavigation = (0,_to_consumable_array/* default */.Z)(navigation).filter(function(e) {
                return e.offsetTop === 0;
            }).map(function(e) {
                return e.innerText;
            });
            setMoreNavElement(moreNavigation);
        };
        var timeoutId = setTimeout(updateNavigation, 0);
        window.addEventListener("resize", updateNavigation);
        return function() {
            window.removeEventListener("resize", updateNavigation);
            clearTimeout(timeoutId);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarWebWrapper, {
        className: className,
        minimize: minimize,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNavigations, {
                ref: navHorizontalRef,
                minimize: minimize,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreWrapper, {
                minimize: minimize,
                Logo: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandNavLogo, {});
                },
                elementToHide: moreNavElement.length,
                children: children
            })
        ]
    });
};
/* harmony default export */ var NavbarWeb = (NavBarComponent);

;// CONCATENATED MODULE: ./src/@deprecated-ui/header/PopoverCustom.js

function PopoverCustom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    PopoverCustom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PopoverCustom_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: inline-block;\n  cursor: pointer;\n"
    ]);
    PopoverCustom_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PopoverCustom_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    PopoverCustom_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PopoverCustom_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n"
    ]);
    PopoverCustom_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var PopoverCustom_Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b31e7793-0"
})(PopoverCustom_templateObject());
var ComponentTrigger = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b31e7793-1"
})(PopoverCustom_templateObject1());
var PopoverDisplay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b31e7793-2"
})(PopoverCustom_templateObject2(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "inline-block" : "none";
});
var PopoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b31e7793-3"
})(PopoverCustom_templateObject3(), color/* default.lowgray */.Z.lowgray);
var Popover = function(param) {
    var children = param.children, componentTrigger = param.componentTrigger;
    var ref = (0,react.useState)(false), isPopoverVisible = ref[0], setVisibilityPopover = ref[1];
    var popoverRef = (0,react.useRef)();
    var componentTriggerRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var onNavExpandClick = function(e) {
            if (componentTriggerRef.current.contains(e.target)) {
                return setVisibilityPopover(!isPopoverVisible);
            }
            if (popoverRef.current.contains(e.target)) {
                return setVisibilityPopover(true);
            }
            return setVisibilityPopover(false);
        };
        document.addEventListener("click", onNavExpandClick);
        // Clean eventlistener when unmount component
        return function() {
            document.removeEventListener("click", onNavExpandClick);
        };
    }, [
        isPopoverVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverCustom_Relative, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentTrigger, {
                ref: componentTriggerRef,
                isActive: isPopoverVisible,
                children: componentTrigger(isPopoverVisible)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverDisplay, {
                ref: popoverRef,
                isVisible: isPopoverVisible,
                children: children
            })
        ]
    });
};

/* harmony default export */ var PopoverCustom = (Popover);

;// CONCATENATED MODULE: ./src/@deprecated-ui/header/index.js





/***/ }),

/***/ 10699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconSettingSupport; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconSettingSupport() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_652_347)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.36833 7.25001C4.65417 4.94584 6.62 3.16667 9 3.16667C10.2892 3.16667 11.4558 3.69167 12.3017 4.53167C13.0133 5.24917 13.4975 6.19417 13.6317 7.25001",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.1667 13.515C11.6051 13.1464 12.7785 12.1085 13.3281 10.7522",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.75 7.25H4.91667V10.75H3.75C3.10834 10.75 2.58334 10.225 2.58334 9.58333V8.41667C2.58334 7.775 3.10834 7.25 3.75 7.25Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.25 10.75H13.0833V7.25H14.25C14.8917 7.25 15.4167 7.775 15.4167 8.41667V9.58333C15.4167 10.225 14.8917 10.75 14.25 10.75Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8.125 13.3917H9.875C10.0269 13.3917 10.15 13.5148 10.15 13.6667C10.15 13.8185 10.0269 13.9417 9.875 13.9417H8.125C7.97312 13.9417 7.85 13.8185 7.85 13.6667C7.85 13.5148 7.97312 13.3917 8.125 13.3917Z",
                        fill: "#333333",
                        stroke: "currentColor",
                        strokeWidth: "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_652_347",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 13084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconChat; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconChat() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M25 9V19C25 20.1 24.1 21 23 21H9L5 25V9C5 7.9 5.9 7 7 7H23C24.1 7 25 7.9 25 9Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 10714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconOrderbook; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconOrderbook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.3332 1.3335H3.6665C3.11422 1.3335 2.6665 1.78121 2.6665 2.3335V13.6668C2.6665 14.2191 3.11422 14.6668 3.6665 14.6668H12.3332C12.8855 14.6668 13.3332 14.2191 13.3332 13.6668V2.3335C13.3332 1.78121 12.8855 1.3335 12.3332 1.3335Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.6665 4L13.3332 4",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.3335 8H5.9935",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.99951 8H10.6662",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.3335 10.666H5.9935",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.99951 10.666H10.6662",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 40261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconPortfolio; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconPortfolio() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2545_9726)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.5648 9.75055C12.824 12.1189 10.6132 13.8339 7.99984 13.8339C4.77984 13.8339 2.1665 11.2205 2.1665 8.00055C2.1665 5.38721 3.8815 3.17638 6.24984 2.43555",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M13.8333 8.00033H8V2.16699C11.2258 2.16699 13.8333 4.78033 13.8333 8.00033Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2545_9726",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(1 1)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 80056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var features_chat_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33037);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var _tests_constant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(376);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19546);







function AttachmentPreview(param) {
    var type = param.type;
    if (type === "ATTACHMENT_TYPE_GIF") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: "/icon/preview-gif.svg",
            alt: "Gif icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_PHOTO") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: "/icon/preview-photo.svg",
            alt: "Photo icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_POST") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: "/icon/preview-post.svg",
            alt: "Post icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_PDF") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: "/icon/preview-pdf.svg",
            alt: "Post icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_STICKER") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: "/icon/preview-sticker.svg",
            alt: "Post icon"
        });
    }
    return null;
}
function LastMessagePreview(param) {
    var message = param.message, showSenderUsername = param.showSenderUsername;
    var attachmentType = message.type, tmp = message.sender_username, senderUsername = tmp === void 0 ? "" : tmp, isDeleted = message.is_deleted;
    var parseLastMessage = function() {
        var isMessageEmpty = (message === null || message === void 0 ? void 0 : message.text) === "";
        if (attachmentType === "ATTACHMENT_TYPE_STICKER") {
            return "Sticker";
        }
        if (attachmentType === "ATTACHMENT_TYPE_GIF") {
            return "GIF";
        }
        if (attachmentType === "ATTACHMENT_TYPE_PHOTO" && isMessageEmpty) {
            return "Photo";
        }
        if (attachmentType === "ATTACHMENT_TYPE_POST" && isMessageEmpty) {
            return "Post";
        }
        return message === null || message === void 0 ? void 0 : message.text;
    };
    var showedMessage = parseLastMessage();
    var asteriskRemover = (0,features_chat_utils__WEBPACK_IMPORTED_MODULE_3__/* .removeFormat */ .Ir)(showedMessage);
    if (isDeleted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .DeletedLastMessage */ ._c, {
            ellipsis: true,
            "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_6__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED */ .Jf,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: "/icon/chat-bubble-removed-gray.svg"
                }),
                asteriskRemover
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        width: "90%",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray,
        ellipsis: true,
        "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_6__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW */ .c2,
        children: [
            showSenderUsername && senderUsername ? "".concat(senderUsername, ": ") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AttachmentPreview, {
                type: attachmentType
            }),
            asteriskRemover
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LastMessagePreview);


/***/ }),

/***/ 40892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dj": function() { return /* reexport */ Icons_ChevronRightSvg; },
  "V3": function() { return /* reexport */ Icons_DropDownSvg; },
  "iD": function() { return /* reexport */ Icons_LightningBoxSvg; },
  "SY": function() { return /* reexport */ Icons_LightningFilledSvg; },
  "Sf": function() { return /* reexport */ Icons_LightningSvg; },
  "bC": function() { return /* reexport */ Icons_TimerClockSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningSvg.tsx

var LightningSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1561_100863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z",
                    stroke: fill,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1561_100863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningSvg = (LightningSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningFilledSvg.tsx

var LightningFilledSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_118194)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 1L5 3.5L7 4.25L3.5 8L4 5.5L2 4.75L5.5 1Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_118194",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningFilledSvg = (LightningFilledSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningBoxSvg.tsx

var LightningBoxSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                stroke: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4016_142863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.75 3.625L10.125 6.75L12.625 7.6875L8.25 12.375L8.875 9.25L6.375 8.3125L10.75 3.625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4016_142863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white",
                        transform: "translate(4.5 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningBoxSvg = (LightningBoxSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/ChevronRightSvg.tsx

var ChevronRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_110905)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.51562 8.70331L7.21933 4.9996L3.51562 1.2959",
                    stroke: "#969696",
                    strokeOpacity: "0.6",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_110905",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ChevronRightSvg = (ChevronRightSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/DropDownSvg.tsx

var DropDownSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#00AB6B" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 6L8.5 10L12.5 6",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_DropDownSvg = (DropDownSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/TimerClockSvg.tsx

var TimerClockSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "6.00156",
                cy: "6.7252",
                r: "3.775",
                stroke: "#8277F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 4.5874V6.9624L7.1875 7.9124",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.60934",
                y1: "2.90025",
                x2: "3.457",
                y2: "1.42212",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "2.86616",
                y2: "-0.5",
                transform: "matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)",
                stroke: "#8277F8",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_TimerClockSvg = (TimerClockSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/index.ts









/***/ }),

/***/ 53400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ DesktopAppDownloadAnalytics; }
/* harmony export */ });
/* unused harmony export EVENT */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var EVENT = {
    openDesktopAppLandingPage: "Open Desktop App Landing Page",
    onDownloadDesktopApp: "Download Desktop App"
};
var DesktopAppDownloadAnalytics = {
    onDesktopAppLandingPage: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.openDesktopAppLandingPage);
    },
    onDownloadDesktopApp: function(param) {
        var os = param.os, source = param.source;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.onDownloadDesktopApp, {
            Source: source,
            OS: os
        });
    }
};


/***/ }),

/***/ 45173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSecuritiesButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91635);
/* harmony import */ var features_trade_components_OrderTable_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83100);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70362);
/* harmony import */ var lib_stores_trading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76260);
/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71158);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7639);
/* harmony import */ var typings_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97718);
/* harmony import */ var utils_crisp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65458);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34385);












function useSecuritiesButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var resetUIValue = (0,stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(s) {
        return s.resetUIValue;
    });
    var resetMultiPortoState = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(s) {
        return s.resetState;
    });
    var handleLogoutTrading = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var securitiesPathPattern, isSecuritiesPage, ref, ref1, ref2, ref3;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getState */ .Z.getState().loadLogout();
                    case 3:
                        securitiesPathPattern = /securities\/.+/;
                        isSecuritiesPage = securitiesPathPattern.test(router.asPath);
                        lib_stores_trading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getState */ .Z.getState().resetErrorCode();
                        global_TradingModal_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().resetModal();
                        features_trade_components_OrderTable_store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getState */ .Z.getState().resetOrderTableStore();
                        // reset eipo token
                        localStorage.removeItem("eipoToken");
                        localStorage.removeItem("eipoRefreshToken");
                        resetUIValue(typings_auth__WEBPACK_IMPORTED_MODULE_8__/* .LoginType.Securities */ .B.Securities);
                        // reset multi portfolio store
                        resetMultiPortoState();
                        if (!isSecuritiesPage) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 15;
                        return router.push("/stream");
                    case 15:
                        return _ctx.abrupt("return");
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        (0,utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ctx.t0, {
                            event: "TradingMenuItem@handleNavigation",
                            errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error_type,
                            errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message
                        });
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return function handleLogoutTrading() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickSupportButton = function() {
        (0,utils_crisp__WEBPACK_IMPORTED_MODULE_9__/* .handleClickSupport */ .lA)();
    };
    return {
        handleLogoutTrading: handleLogoutTrading,
        handleClickSupportButton: handleClickSupportButton
    };
};


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};



/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 65743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70175);





var InitialTradeWeb = function() {
    var showAuthModal = (0,features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.showModal;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            padding: "16px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            onClick: function() {
                return showAuthModal();
            },
            style: {
                background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].trading */ .Z.trading
            },
            margin: "10px 0",
            height: "36px",
            block: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                weight: "bold",
                size: "14px",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light,
                align: "center",
                children: "START TRADING"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InitialTradeWeb);


/***/ }),

/***/ 27271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Message_Mobile; },
  "p": function() { return /* reexport */ Message_Web; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
;// CONCATENATED MODULE: ./src/global/Header/Message/__tests__/constant.ts
var MOCK_USER_LOGGED_IN = {
    id: 111,
    username: "user-testing",
    country: "ID"
};
// MessageIcon
var DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT = "message-icon-inbox-chat-menu";
// MessageHeader
var DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT = "message-header-inbox-chat-menu";
var DATA_CY_NAME_MESSAGE_HEADER_REQUESTS = "message-header-inbox-chat-requests";
// MessageList
var DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST = "message-header-inbox-chat-message-list";
var DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY = "message-header-inbox-chat-message-list-empty";
// MessageItem
var DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT = "message-item-inbox-chat-menu";
// MessageItemAvatar
var DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT = "message-item-avatar-chat-menu";
// See All in Chat Button
var DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON = "message-header-inbox-chat-see-all-button";
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " should render successfully")
    };
};
var MOCK_COUNT_NOTIFICATION = {
    ZERO: 0,
    MORE_THAN_ZERO: 1,
    MORE_THAN_99: 100
};
var ROOM_LIST = {
    FILE_MOCK_NAME: {
        EMPTY: "EmptyRoomList",
        ACCEPTED: "AcceptedRoomList",
        INVITED: "InvitedRoomList"
    }
};
var MOCK_MESSAGE_ITEM = {
    id: 0,
    type: "ROOM_TYPE_GROUP",
    info: {
        name: "test lagi",
        shortened_name: "TL",
        description: "",
        avatar_url: ""
    },
    attributes: {
        group: {
            member_description: ""
        }
    },
    unread_count: 0,
    last_message: {
        text: "aaa",
        sender_username: "sender_username",
        type: "ATTACHMENT_TYPE_UNSPECIFIED",
        created_at: "2023-03-14T03:12:26Z",
        is_deleted: false,
        id: 1222222222
    },
    status: {
        is_muted: false,
        is_mentioned: false
    },
    state: "ROOM_STATE_ACCEPTED",
    unread_message: {
        total: 0,
        last_id: 12
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/header/index.js + 2 modules
var header = __webpack_require__(37944);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Header/Message/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-popover-content {\n    border-radius: 6px !important;\n    border: 1px solid ",
        ";\n\n    .ant-popover-inner {\n      border-radius: 6px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: none;\n  overflow-y: auto;\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* border-bottom: 1px solid ",
        "; */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 10px;\n  min-width: 19px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 6px;\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 325px;\n  height: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 16px;\n  }\n  & > :last-child {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n  i {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 12px;\n\n  & > img {\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 52px);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: 'space-between';\n  align-items: 'center';\n  flex-grow: 1;\n\n  p > img {\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  min-width: 18px;\n  height: 18px;\n  line-height: 18px;\n  padding: 0 2px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  font-size: 11px;\n  color: ",
        ";\n  text-align: center;\n  border: 1px solid #8f8f8f;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: ",
        ";\n  padding: 0px 20px;\n\n  & > div {\n    width: 101px;\n    height: 18px;\n    border-radius: 4px;\n    background-color: #f7f7f7;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background: ",
        ";\n  padding: 0px 20px;\n\n  & > div:first-child {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: #f7f7f7;\n    margin-right: 10px;\n  }\n\n  & > div:nth-child(2) > span:first-child {\n    display: block;\n    width: 101px;\n    height: 12px;\n    border-radius: 4px;\n    margin-bottom: 5px;\n    background-color: #f7f7f7;\n  }\n\n  & > div:nth-child(2) > span:nth-child(2) {\n    display: block;\n    width: 230px;\n    height: 12px;\n    border-radius: 4px;\n    background-color: #f7f7f7;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n\n  & > div {\n    width: 101px;\n    height: 19px;\n    border-radius: 4px;\n    background-color: #f7f7f7;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  padding: 20px;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}








var PopoverWeb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
var CustomPopoverContainer = (0,styled_components_browser_esm/* default */.ZP)(header/* PopoverContainer */.OI).withConfig({
    componentId: "sc-c03a4ac8-1"
})(_templateObject1(), color/* default.light */.Z.light);
var PopoverContentMobile = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContent */.yk).withConfig({
    componentId: "sc-c03a4ac8-2"
})(_templateObject2(), color/* default.gainsboro */.Z.gainsboro);
var MessageListContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function(props) {
    return {
        align: "center",
        padding: "10px 20px",
        isNew: props.isNew
    };
}).withConfig({
    componentId: "sc-c03a4ac8-3"
})(_templateObject3(), color/* default.downgray */.Z.downgray, color/* default.black */.Z.black);
var UnreadMessage = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    color: color/* default.light */.Z.light,
    weight: "500",
    size: "11px",
    align: "center",
    padding: "3px 2px"
}).withConfig({
    componentId: "sc-c03a4ac8-4"
})(_templateObject4(), color/* default.primary */.Z.primary);
var PopoverWrapperWeb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-5"
})(_templateObject5());
var PopoverContentWeb = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContent */.yk).withConfig({
    componentId: "sc-c03a4ac8-6"
})(_templateObject6());
var RoomItemStatus = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-c03a4ac8-7"
})(_templateObject7());
var GroupAvatar = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c03a4ac8-8"
})(_templateObject8());
var AvatarContainer = (0,styled_components_browser_esm/* default */.ZP)(Avatar/* default */.Z).withConfig({
    componentId: "sc-c03a4ac8-9"
})(_templateObject9(), color/* default.component */.Z.component, color/* default.lowgray */.Z.lowgray);
var MessageItemBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-10"
})(_templateObject10());
var MessageItemContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-c03a4ac8-11"
})(_templateObject11());
var MessageCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c03a4ac8-12"
})(_templateObject12(), color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var PopoverHeaderLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-13"
})(_templateObject13(), color/* default.light */.Z.light);
var PopoverListLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-14"
})(_templateObject14(), color/* default.light */.Z.light);
var PopoverFooterLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c03a4ac8-15"
})(_templateObject15(), color/* default.light */.Z.light);
var PopoverFooter = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "a",
    color: color/* default.primary */.Z.primary,
    align: "center",
    family: "bold"
}).withConfig({
    componentId: "sc-c03a4ac8-16"
})(_templateObject16(), color/* default.light */.Z.light);
var NoMesageIcon = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-c03a4ac8-17"
})(_templateObject17());


;// CONCATENATED MODULE: ./src/global/Header/Message/MessageHeader.tsx








function MessageHeader(param) {
    var _unreadRequest = param.unreadRequest, unreadRequest = _unreadRequest === void 0 ? 0 : _unreadRequest;
    var router = (0,next_router.useRouter)();
    var isLoading = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.isLoading;
    });
    var onClickRequest = function() {
        router.push("/chat?type=request");
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverHeaderLoading, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        padding: "16px 20px",
        justify: "space-between",
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                weight: "400",
                children: "Messages"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: color/* default.primary */.Z.primary,
                as: "span",
                onClick: onClickRequest,
                style: {
                    cursor: "pointer"
                },
                "data-cy": DATA_CY_NAME_MESSAGE_HEADER_REQUESTS,
                children: [
                    "Requests ",
                    unreadRequest >= 1 && "(".concat(unreadRequest, ")")
                ]
            })
        ]
    });
}
/* harmony default export */ var Message_MessageHeader = (MessageHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/utils/time.js
var time = __webpack_require__(10200);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./src/features/chat/LeftSidebar/ChatRooms/LastMessagePreview.tsx
var LastMessagePreview = __webpack_require__(80056);
// EXTERNAL MODULE: ./src/global/Labels/LabelBroadcast.tsx
var LabelBroadcast = __webpack_require__(7162);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/global/Header/Message/MessageItemAvatar.tsx






function RoomItemAvatar(param) {
    var type = param.type, src = param.src, name = param.name, shortName = param.shortName, isDeactive = param.isDeactive;
    if (type === "ROOM_TYPE_PERSONAL") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
            "data-cy": DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isDeactive,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/avatar.png",
                        alt: "User Not Found Avatar"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: !isDeactive,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: name,
                        src: src,
                        onError: function(e) {
                            return (0,general/* handleErrorAvatar */.Tk)(e, name);
                        }
                    })
                })
            ]
        });
    }
    var hasImage = src !== "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
        "data-cy": DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !hasImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupAvatar, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        "data-username": name,
                        children: shortName
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: hasImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: name,
                    src: src,
                    onError: function(e) {
                        return (0,general/* handleErrorAvatar */.Tk)(e, name);
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var MessageItemAvatar = (RoomItemAvatar);

;// CONCATENATED MODULE: ./src/global/Header/Message/MessageItem.tsx




















var MessageItem = function(param) {
    var item = param.item, onClick = param.onClick;
    var ref, ref1, ref2;
    // @ts-ignore
    var username = auth/* default.getUserAccess */.Z.getUserAccess().username;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref3.data;
    var id = item.id, attributes = item.attributes, _info = item.info, name = _info.name, shortName = _info.shortened_name, avatarUrl = _info.avatar_url, type = item.type, _status = item.status, isMuted = _status.is_muted, isMentioned = _status.is_mentioned, lastMessage = item.last_message, unreadCount = item.unread_count;
    var showSenderUsername = type === "ROOM_TYPE_GROUP" && username !== (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender_username) && (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender_username) !== "";
    var isDeactivated = attributes === null || attributes === void 0 ? void 0 : (ref = attributes.personal) === null || ref === void 0 ? void 0 : ref.is_deactivated;
    var isVerified = attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.personal) === null || ref1 === void 0 ? void 0 : ref1.is_verified;
    var verifiedStatus = attributes === null || attributes === void 0 ? void 0 : (ref2 = attributes.personal) === null || ref2 === void 0 ? void 0 : ref2.verified_status;
    var onClickChat = function() {
        onClick();
        var chatUrl = "";
        switch(type){
            case "ROOM_TYPE_BROADCAST":
                chatUrl = "broadcast-chat";
                break;
            case "ROOM_TYPE_GROUP":
                chatUrl = "group-chat";
                break;
            case "ROOM_TYPE_PERSONAL":
                chatUrl = "chat";
                break;
        }
        router.push("/".concat(chatUrl, "/").concat(id, "?source=").concat(constant/* SOURCE_CHAT_ROOM_VIEWED.findIndex */.VY.findIndex(function(x) {
            return x === "Inbox Chat";
        })));
    };
    var asteriskRemoved = (0,utils/* removeFormat */.Ir)(lastMessage);
    var isBroadcast = type === "ROOM_TYPE_BROADCAST";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageListContainer, {
        onClick: onClickChat,
        "data-cy": DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageItemAvatar, {
                isDeactive: isDeactivated,
                name: name,
                src: avatarUrl,
                shortName: shortName,
                type: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItemBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        justify: "space-between",
                        mb: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                width: "calc(100% - 100px)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        family: "bold",
                                        ellipsis: true,
                                        children: isDeactivated ? "Stockbit User" : name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: isVerified,
                                        verifiedStatus: verifiedStatus
                                    }),
                                    isBroadcast && // @ts-expect-error
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        ml: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelBroadcast/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "11px",
                                color: color/* default.midgray */.Z.midgray,
                                elipsis: true,
                                children: (0,time/* default */.Z)(lastMessage.created_at, dataProfile.country)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItemContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMessagePreview/* default */.Z, {
                                message: asteriskRemoved,
                                showSenderUsername: showSenderUsername
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoomItemStatus, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isMuted,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/muted-grey.svg",
                                            width: "16",
                                            height: "17",
                                            alt: "mentioned"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isMentioned,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/mention-green.svg",
                                            width: "16",
                                            height: "17",
                                            alt: "mentioned"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: unreadCount > 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnreadMessage, {
                                            children: unreadCount > 99 ? "99+" : unreadCount
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Message_MessageItem = (MessageItem);

;// CONCATENATED MODULE: ./src/global/Header/Message/MessageList.tsx











var MessageList = function() {
    var rooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var isLoading = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.isLoading;
    });
    var fetchRooms = (0,chat/* default */.Z)(function(store) {
        return store.fetchDefaultRooms;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        fetchRooms({
            offset: 0,
            limit: 25
        });
    }, []);
    var markAsReadItem = function(id) {
        return function() {
            dispatch(slice/* effects.readChat */.Sz.readChat(id));
        };
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: (0,_to_consumable_array/* default */.Z)(new Array(5)).map(function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverListLoading, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                            ]
                        })
                    ]
                });
            })
        });
    }
    if (rooms.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-cy": DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST,
            children: rooms.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageItem, {
                    item: item,
                    onClick: markAsReadItem(item.id)
                }, item.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        direction: "column",
        align: "center",
        justify: "center",
        // @ts-expect-error
        p: "15px 0",
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMesageIcon, {
                src: "/icon/message-no-list.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: "No Recent Chat ..."
            })
        ]
    });
};
/* harmony default export */ var Message_MessageList = (MessageList);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconChat.tsx
var IconChat = __webpack_require__(13084);
;// CONCATENATED MODULE: ./src/global/Header/Message/MessageIcon.tsx









var MessageIcon = function(_param) /*#__PURE__*/ {
    var count = _param.count, props = (0,_object_without_properties/* default */.Z)(_param, [
        "count"
    ]);
    return (0,jsx_runtime.jsxs)(Iconmoon/* IconWrapper */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        size: "40px",
        "data-cy": DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT,
        style: {
            marginRight: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: "#969696",
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChat/* default */.Z, {})
            }),
            count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageCount, {
                children: count > 99 ? "99+" : count
            })
        ]
    }));
};
/* harmony default export */ var Message_MessageIcon = (MessageIcon);

;// CONCATENATED MODULE: ./src/global/Header/Message/Mobile.tsx












var Mobile = function() {
    var router = (0,next_router.useRouter)();
    var unreadCount = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return s.count;
    });
    var unreadRequest = (0,chat/* default */.Z)(function(s) {
        return s.rooms.default.unreadRequest;
    });
    // Event handlers
    var handleSeeAllClick = function() {
        router.push("".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat"));
    };
    var Footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooter, {
        onClick: handleSeeAllClick,
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON,
        children: "See All in Chat"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
        trigger: "click",
        placement: "bottom",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        overlayInnerStyle: {
            borderBottom: "unset"
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPopoverContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        borderBottom: "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro)
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageHeader, {
                            unreadRequest: unreadRequest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentMobile, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageList, {})
                        }),
                        Footer
                    ]
                })
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageIcon, {
            count: unreadCount
        })
    });
};
/* harmony default export */ var Message_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/Header/Message/Web.tsx











var Web = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            unreadCount: s.count,
            resetCount: s.resetCounter
        };
    }), unreadCount = ref.unreadCount, resetCount = ref.resetCount;
    var unreadRequest = (0,chat/* default */.Z)(function(s) {
        return s.rooms.default.unreadRequest;
    });
    var isLoading = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.isLoading;
    });
    // Event handlers
    var handleSeeAllClick = function() {
        router.push("".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat"));
    };
    var Footer = isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooterLoading, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooter, {
        onClick: handleSeeAllClick,
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON,
        children: "See All in Chat"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                trigger: "click",
                placement: "bottomRight",
                overlayStyle: {
                    width: "400px",
                    border: "unset !important"
                },
                getPopupContainer: function() {
                    return document.getElementById("inbox-chat-popup");
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverWrapperWeb, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageHeader, {
                                unreadRequest: unreadRequest
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentWeb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageList, {})
                            }),
                            Footer
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageIcon, {
                    count: unreadCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverWeb, {
                id: "inbox-chat-popup"
            })
        ]
    });
};
/* harmony default export */ var Message_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/Message/index.jsx




/***/ }),

/***/ 70826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Navbar_Mobile; },
  "p": function() { return /* reexport */ Navbar_Web; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/header/index.js + 2 modules
var header = __webpack_require__(37944);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/utils/navbar.js

var generateNavBar = function(data) {
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var baseMenu = [
        {
            label: "Stream",
            href: "/stream",
            logoWeb: "icon-menu_home",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/stream")) {
                    return true;
                }
                return false;
            },
            logoMobile: "icon-menu3_home",
            "data-cy": "navbar-stream"
        },
        {
            label: "Profile",
            logoWeb: "icon-menu_profile",
            href: "/".concat(data.username),
            matcher: function(router) {
                var asPath = router.asPath;
                if (data.username && asPath.includes("/".concat(data.username))) {
                    return true;
                }
                return false;
            },
            logoMobile: "icon-menu3_profile",
            "data-cy": "navbar-profile"
        },
        {
            label: "Watchlist",
            href: "/watchlist",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/watchlist")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_watchlist",
            logoMobile: "icon-menu3_watchlist",
            "data-cy": "navbar-watchlist"
        },
        {
            label: "Portfolio",
            href: "/securities/portfolio",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/securities/portfolio")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_portfolio",
            logoMobile: "icon-menu3_portfolio",
            "data-cy": "navbar-portfolio"
        },
        {
            label: "Orderbook",
            href: "/orderbook",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/orderbook")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_orderbook",
            logoMobile: "icon-menu3_orderbook",
            "data-cy": "navbar-orderbook"
        }, 
    ];
    var mockMenu = [
        {
            label: "Chartbit",
            href: "/symbol/IHSG/chartbit",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/chartbit")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_chartbit",
            logoMobile: "icon-menu3_chartbit",
            "data-cy": "navbar-chartbit"
        },
        {
            label: "e-IPO",
            href: "/e-ipo",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/e-ipo")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu3_eipo",
            logoMobile: "icon-menu3_eipo",
            "data-cy": "navbar-ipo"
        },
        {
            label: "Screener",
            href: "/screener",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/screener")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_screener",
            logoMobile: "icon-menu3_screener",
            "data-cy": "navbar-screener"
        },
        {
            label: "Academy",
            href: "/academy?refresh=1",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/unboxing")) {
                    return true;
                }
                if (asPath.includes("/academy")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_academy",
            logoMobile: "icon-menu3_academy",
            "data-cy": "navbar-academy"
        },
        {
            label: "Valuation",
            href: "/valuation",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/valuation")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_valuation",
            logoMobile: "icon-menu3_valuation",
            "data-cy": "navbar-valuation"
        },
        {
            label: "Financials",
            href: "/symbol/AALI/financials",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/financials")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_financials",
            logoMobile: "icon-menu3_financials",
            "data-cy": "navbar-financials"
        },
        {
            label: "Fundachart",
            href: "/symbol/AALI/fundachart",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/fundachart")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_fundachart",
            logoMobile: "icon-menu3_fundachart",
            "data-cy": "navbar-fundachart"
        },
        {
            label: "Seasonality",
            href: "/symbol/AALI/seasonality",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/seasonality")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_seasonality",
            logoMobile: "icon-menu3_seasonality",
            "data-cy": "navbar-seasonality"
        },
        {
            label: "Sector",
            href: "/sector",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/sector")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_sector",
            logoMobile: "icon-menu3_sector",
            "data-cy": "navbar-sector"
        },
        {
            label: "Calendar",
            href: "/calendar",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/calendar")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_calendar",
            logoMobile: "icon-menu3_calendar",
            "data-cy": "navbar-calendar"
        },
        {
            label: "Earnings",
            href: "/earnings",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/earnings")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_earning",
            logoMobile: "icon-menu3_earning",
            "data-cy": "navbar-earning"
        },
        {
            label: "Glossary",
            href: "/glossary",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/glossary")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_glossary",
            logoMobile: "icon-menu3_glossary",
            "data-cy": "navbar-glossary"
        },
        {
            label: "Ebook",
            href: "/ebook",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/ebook")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_ebook",
            logoMobile: "icon-menu3_ebook",
            "data-cy": "navbar-ebook"
        }, 
    ];
    if (country === "MY") {
        return baseMenu;
    }
    return (0,_to_consumable_array/* default */.Z)(baseMenu).concat((0,_to_consumable_array/* default */.Z)(mockMenu));
};
/* harmony default export */ var navbar = (generateNavBar);

// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/global/Header/RealTrading/Mobile.tsx + 11 modules
var Mobile = __webpack_require__(87671);
// EXTERNAL MODULE: ./src/global/Header/VirtualTrading/Mobile.tsx
var VirtualTrading_Mobile = __webpack_require__(13263);
// EXTERNAL MODULE: ./src/global/Header/InitialTrading/Mobile.jsx
var InitialTrading_Mobile = __webpack_require__(65743);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Header/Navbar/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: unset;\n  border: none;\n  overflow-y: auto;\n  background-color: white;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-right: 1px solid ",
        ";\n\n  ::after {\n    position: absolute;\n    content: '';\n    width: 100%;\n    height: 1px;\n    top: 100%;\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n\n  & > span {\n    display: inline-block;\n    height: 1px;\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 0;\n  background-color: white;\n  border-top-color: ",
        ";\n\n  div:nth-child(2) {\n    :nth-child(2) {\n      background: ",
        ";\n      border-top: none;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height : 40px;\n    background-color: white;\n    color : ",
        ";\n\n    @media only screen and (min-width: 1917px) and (max-width: 1940px){\n      padding: 12px;\n    } \n\n    @media only screen and (min-width: 2040px) {\n      padding: 13px;\n    } \n\n    \n    :hover,\n    a:hover{\n      color : ",
        ";\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var PopoverNavbarContainer = (0,styled_components_browser_esm/* default */.ZP)(header/* PopoverContainer */.OI).withConfig({
    componentId: "sc-545e90e4-0"
})(_templateObject());
var IconClose = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-545e90e4-1"
})(_templateObject1(), color/* default.midgray */.Z.midgray, color/* default.light */.Z.light);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-545e90e4-2"
})(_templateObject2(), color/* default.downgray */.Z.downgray);
var LogoExpand = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-545e90e4-3"
})(_templateObject3(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, color/* default.midgray */.Z.midgray);
var NavigationMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-545e90e4-4"
})(_templateObject4(), color/* default.downgray */.Z.downgray, color/* default.downgray */.Z.downgray);
var NavbarWeb = (0,styled_components_browser_esm/* default */.ZP)(header/* NavbarWeb */.IB).withConfig({
    componentId: "sc-545e90e4-5"
})(_templateObject5(), color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light);
var Navigation = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        // @ts-expect-error
        active: props.active,
        align: "center",
        p: "14px"
    };
}).withConfig({
    componentId: "sc-545e90e4-6"
})(_templateObject6(), function(param) {
    var active = param.active;
    return active ? color/* default.primary */.Z.primary : "#858585";
}, function(param) {
    var active = param.active;
    return active ? color/* default.primary */.Z.primary : color/* default.highempahis */.Z.highempahis;
});
var NavLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-545e90e4-7"
})(_templateObject7());


;// CONCATENATED MODULE: ./src/global/Header/Navbar/ExpandMenuOpen.jsx



var ExpandMenuOpen = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoExpand, {
        size: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
};
ExpandMenuOpen.propTypes = {
    size: (prop_types_default()).string
};
ExpandMenuOpen.defaultProps = {
    size: "20px"
};
/* harmony default export */ var Navbar_ExpandMenuOpen = (ExpandMenuOpen);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/global/Header/Navbar/ReloadHandler.tsx



var ReloadHandler = function(param) {
    var children = param.children, href = param.href, label = param.label, onClick = param.onClick, isMobile = param.isMobile;
    var NavWrapper = isMobile ? NavigationMobile : NavLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavWrapper, {
            onClick: onClick,
            children: children
        }, label)
    }, label);
};
/* harmony default export */ var Navbar_ReloadHandler = (ReloadHandler);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconStream.tsx


function IconStream() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2545_9709)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.6875 2.375H3.3125C2.79375 2.375 2.375 2.79375 2.375 3.3125V12.6875C2.375 13.2062 2.79375 13.625 3.3125 13.625H12.6875C13.2062 13.625 13.625 13.2062 13.625 12.6875V3.3125C13.625 2.79375 13.2062 2.375 12.6875 2.375Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.74805 6.28809H10.248",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.74805 9.68652H10.248",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2545_9709",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconProfile.tsx


function IconProfile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99988 8.24C9.58494 8.24 10.8699 6.95506 10.8699 5.37C10.8699 3.78494 9.58494 2.5 7.99988 2.5C6.41483 2.5 5.12988 3.78494 5.12988 5.37C5.12988 6.95506 6.41483 8.24 7.99988 8.24Z",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.2602 13.5002C13.2602 10.5902 10.9002 8.24023 8.00023 8.24023C5.10023 8.24023 2.74023 10.6002 2.74023 13.5002H13.2602Z",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconWatchlist.tsx


function IconWatchlist() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.29892 1.40521L10.1389 5.15188L14.2723 5.74521C14.5456 5.78521 14.6523 6.11855 14.4589 6.31188L11.4656 9.22521L12.1789 13.3385C12.2256 13.6119 11.9389 13.8185 11.6923 13.6919L7.99892 11.7452L4.30559 13.6919C4.05893 13.8185 3.77226 13.6119 3.81892 13.3385L4.53226 9.22521L1.53893 6.31188C1.33893 6.11855 1.45226 5.78521 1.72559 5.74521L5.85892 5.15188L7.69892 1.40521C7.81892 1.15855 8.17226 1.15855 8.29892 1.40521Z",
            stroke: "currentColor",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconChat.tsx
var IconChat = __webpack_require__(13084);
;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconChartbit.tsx


function IconChartbit() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.333 4H10.333C9.78072 4 9.33301 4.44772 9.33301 5V11C9.33301 11.5523 9.78072 12 10.333 12H12.333C12.8853 12 13.333 11.5523 13.333 11V5C13.333 4.44772 12.8853 4 12.333 4Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.66638 4.66663H3.66638C3.1141 4.66663 2.66638 5.11434 2.66638 5.66663V10.3333C2.66638 10.8856 3.1141 11.3333 3.66638 11.3333H5.66638C6.21867 11.3333 6.66638 10.8856 6.66638 10.3333V5.66663C6.66638 5.11434 6.21867 4.66663 5.66638 4.66663Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.333 1.33337V4.00004",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.333 12.0067V14.6734",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.65979 2.33337V4.66671",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.65979 11.34V13.6733",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconOrderbook.tsx
var IconOrderbook = __webpack_require__(10714);
;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconEIpo.tsx


function IconEIpo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2545_9755)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip1_2545_9755)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M1.40283 1.46484H14.5973",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13.8478 11.8121L8.00054 14.6176L2.15332 11.8121V1.46484H13.8478V11.8121Z",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M4.51904 4.92383V8.45855",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.4436 4.92383V8.45855",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.08249 4.92383H6.4436V6.69466H8.08249V4.92383Z",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.5066 5.74327C11.5066 5.29071 11.1397 4.92383 10.6871 4.92383C10.2346 4.92383 9.86768 5.29071 9.86768 5.74327V7.51411C9.86768 7.96667 10.2346 8.33355 10.6871 8.33355C11.1397 8.33355 11.5066 7.96667 11.5066 7.51411V5.74327Z",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M4.51904 10.2246L11.6065 10.2246",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2545_9755",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_2545_9755",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "15",
                            height: "15",
                            fill: "white",
                            transform: "translate(0.5 0.5)"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconAcademy.tsx


function IconAcademy() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2545_9771)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.3482 6.00372L8.00074 9.9548L0.65332 6.00372L8.00074 2.06396L15.3482 6.00372Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.531 7.521V11.3362C12.531 11.5853 12.4518 11.8117 12.3046 12.0155C11.8291 12.6495 10.5612 13.9401 8.00258 13.9401C5.444 13.9401 4.16471 12.6495 3.70054 12.0155C3.55337 11.823 3.47412 11.5853 3.47412 11.3362V7.521",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.8228 8.52148V10.0959",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2545_9771",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconScreener.tsx


function IconScreener() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.66545 10V13.3333C9.66545 13.7015 9.36697 14 8.99878 14H6.99878C6.63059 14 6.33211 13.7015 6.33211 13.3333V10L2.35057 5.6693C2.12433 5.42323 1.99878 5.10116 1.99878 4.76689V2.66667C1.99878 2.29848 2.29726 2 2.66545 2H13.3308C13.6995 2 13.9982 2.29929 13.9974 2.668L13.9932 4.81188C13.9925 5.14715 13.8655 5.46987 13.6376 5.71573L9.66545 10Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.66536 4.66016H6.33203",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconValuation.tsx


function IconValuation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99466 14.1933L0.774658 5.93997L4.17466 1.80664H11.828L15.228 5.92664L8.00799 14.18L7.99466 14.1933Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 5.94043H0.761719",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00911 14.18L4.17578 1.80664",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00903 14.18L11.8424 1.80664",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconFinancials.tsx


function IconFinancials() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6667 14.6668H3.33341C2.96675 14.6668 2.66675 14.3668 2.66675 14.0002V2.00016C2.66675 1.6335 2.96675 1.3335 3.33341 1.3335H9.44675C9.80008 1.3335 10.1401 1.4735 10.3867 1.72683L12.9401 4.28016C13.1934 4.5335 13.3334 4.86683 13.3334 5.22016V14.0002C13.3334 14.3668 13.0334 14.6668 12.6667 14.6668Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 1.45312V3.99979C10 4.36646 10.3 4.66646 10.6667 4.66646H13.2133",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12V7",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 12V10",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 12V9",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconFundachart.tsx


function IconFundachart() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.6734 2.6665H2.34009C1.78675 2.6665 1.34009 3.11317 1.34009 3.6665V12.3332C1.34009 12.8865 1.78675 13.3332 2.34009 13.3332H13.6734C14.2268 13.3332 14.6734 12.8865 14.6734 12.3332V3.6665C14.6734 3.11317 14.2268 2.6665 13.6734 2.6665Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.15991 10.4263L4.92658 8.17959C5.05325 8.01959 5.28658 8.00626 5.42658 8.15292L6.85991 9.60626C7.01325 9.75959 7.27325 9.73292 7.37991 9.54626L8.82658 7.13959C8.94658 6.93959 9.23325 6.91959 9.37991 7.11292L10.6799 8.83959C10.8266 9.03959 11.1332 9.00626 11.2466 8.78626L12.8466 5.57959",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconSeasonality.tsx


function IconSeasonality() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.8174 4.69141L11.5742 7.16795L14.0508 8.40132",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8.35209V1.5",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.99969 8.35227L1.5 6.18896",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4997 6.18896L8 8.35227",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.04297 2.62598L8.00071 4.58372L9.94866 2.62598",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.95117 8.40081L4.42771 7.16743L3.18455 4.70068",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.14019 14.108L5.74865 11.3672L3.00781 11.7685",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.0015 11.7587L10.2607 11.3672L9.87891 14.108",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.1113 13.8337L8 8.35205",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.00188 8.35205L3.89062 13.8337",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconSector.tsx


function IconSector() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2C4.69 2 2 4.69 2 8Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8V14",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8H14",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8H14",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8L12.24 12.24",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 8V2",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconCalender.tsx


function IconCalender() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 3H3C2.44772 3 2 3.44772 2 4V12C2 12.5523 2.44772 13 3 13H13C13.5523 13 14 12.5523 14 12V4C14 3.44772 13.5523 3 13 3Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 6.5H14",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 4V2",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5 4V2",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconEarnings.tsx


function IconEarnings() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2545_9831)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip1_2545_9831)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M2.83521 10.8801C2.83521 13.7335 5.14761 14.9003 8.00098 14.9003C10.8544 14.9003 13.1668 13.7335 13.1668 10.8801C13.1668 8.02671 10.8544 4.55811 8.00098 4.55811C5.14761 4.55811 2.83521 8.02671 2.83521 10.8801Z",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9.12494 4.73842H9.14615L10.2493 2.77606C10.61 2.13962 10.2387 1.32285 9.5068 1.20617C9.11433 1.14253 8.61579 1.1001 7.98995 1.1001C7.36412 1.1001 6.86557 1.14253 6.4731 1.20617C5.7518 1.32285 5.36994 2.12901 5.73059 2.77606L6.83375 4.73842H6.85497",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.34985 11.304L7.12128 9.53262L8.8821 10.7206L10.6535 8.94922",
                            stroke: "currentColor",
                            strokeWidth: "1.2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2545_9831",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_2545_9831",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "15.5",
                            height: "15.5",
                            fill: "white",
                            transform: "translate(0.25 0.25)"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconGlossary.tsx


function IconGlossary() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.02 3C3.01 3.06 3 3.13 3 3.2V3H3.02Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 5.4002V13.0002C13 13.5502 12.55 14.0002 12 14.0002H4.5C3.67 14.0002 3 13.3302 3 12.5002V3.2002C3 3.8602 3.54 4.4002 4.2 4.4002H12C12.55 4.4002 13 4.8502 13 5.4002Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.2 2H11V4.4H4.2C3.54 4.4 3 3.86 3 3.2C3 2.54 3.54 2 4.2 2Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 7.2002L6 11.2002",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 7.2002L10 11.2002",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 10.2002H9.5",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconEBook.tsx


function IconEBook() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 4.5V14.5C8 13.4 7.11 12.5 6 12.5H1V2.5H6C7.1 2.5 8 3.4 8 4.5Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 4.5V14.5C8 13.4 8.89 12.5 10 12.5H15V2.5H10C8.9 2.5 8 3.4 8 4.5Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 6H12",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11 9H12",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/Header/Navbar/Mobile.jsx


































function componentTrigger(isButtonActive) {
    if (isButtonActive) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {
            size: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                size: "25px",
                className: "icon-compose_close"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
        size: "60px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_ExpandMenuOpen, {})
    });
}
var Mobile_Mobile = function() {
    var router = (0,next_router.useRouter)();
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var renderTradingPopup = function() {
        if (!tradingType) return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Mobile/* default */.Z, {});
        if (isRealTrading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile/* default */.Z, {});
        if (isVirtualTrading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile/* default */.Z, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-menu3_home":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStream, {});
            case "icon-menu3_profile":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconProfile, {});
            case "icon-menu3_watchlist":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWatchlist, {});
            case "icon-menu3_chat":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChat/* default */.Z, {});
            case "icon-menu3_chartbit":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChartbit, {});
            case "icon-menu3_orderbook":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconOrderbook/* default */.Z, {});
            case "icon-menu3_eipo":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEIpo, {});
            case "icon-menu3_academy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAcademy, {});
            case "icon-menu3_screener":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconScreener, {});
            case "icon-menu3_valuation":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconValuation, {});
            case "icon-menu3_financials":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFinancials, {});
            case "icon-menu3_fundachart":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFundachart, {});
            case "icon-menu3_seasonality":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSeasonality, {});
            case "icon-menu3_sector":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSector, {});
            case "icon-menu3_calendar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalender, {});
            case "icon-menu3_earning":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEarnings, {});
            case "icon-menu3_glossary":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGlossary, {});
            case "icon-menu3_ebook":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEBook, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* PopoverCustom */.Bp, {
        componentTrigger: componentTrigger,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverNavbarContainer, {
            children: [
                renderTradingPopup(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                    children: navbar(data).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar_ReloadHandler, {
                            href: item.href,
                            label: item.label,
                            isMobile: true,
                            "data-cy": item["data-cy"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        color: item.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray
                                    },
                                    children: renderIcon(item.logoMobile)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "a",
                                    size: "11px",
                                    align: "center",
                                    color: item.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray,
                                    children: item.label
                                })
                            ]
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Navbar_Mobile = (Mobile_Mobile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/constants/clevertap.js
var constants_clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconPortfolio.tsx
var IconPortfolio = __webpack_require__(40261);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var store = __webpack_require__(70175);
;// CONCATENATED MODULE: ./src/global/Header/Navbar/Web.jsx






































var NavMoreLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "40px",
        height: "40px",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/navbar-web/tripel-dot.svg",
            alt: "Tripel Dot"
        })
    });
};
var Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var tradingType = (0,useTradingAccount/* default */.Z)().tradingType;
    var navbarRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), showNavMoreLogo = ref[0], setShowNavMoreLogo = ref[1];
    var showAuthModal = (0,store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var tradingModalConfig = (0,store/* default */.Z)(function(state) {
        return state.tradingModalConfig;
    });
    var closeAuthModal = (0,store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    var updateNavMoreLogoVisibility = function() {
        if (navbarRef.current) {
            var width = navbarRef.current.getBoundingClientRect().width; // Get the width of the NavbarWeb
            setShowNavMoreLogo(width <= 1873); // Update state based on width
        }
    };
    (0,react.useEffect)(function() {
        updateNavMoreLogoVisibility();
        // Attach resize event listener
        window.addEventListener("resize", updateNavMoreLogoVisibility);
        return function() {
            // Cleanup listener on unmount
            window.removeEventListener("resize", updateNavMoreLogoVisibility);
        };
    }, []);
    var renderExpand = function() {
        if (country === "ID" && showNavMoreLogo) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-cy": data_cy/* default.NAVIGATION.MORE_MENU_BUTTON */.Z.NAVIGATION.MORE_MENU_BUTTON,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreLogo, {})
            });
        }
        return null;
    };
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-menu3_home":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStream, {});
            case "icon-menu3_profile":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconProfile, {});
            case "icon-menu3_watchlist":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWatchlist, {});
            case "icon-menu3_portfolio":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPortfolio/* default */.Z, {});
            case "icon-menu3_chartbit":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChartbit, {});
            case "icon-menu3_orderbook":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconOrderbook/* default */.Z, {});
            case "icon-menu3_eipo":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEIpo, {});
            case "icon-menu3_academy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAcademy, {});
            case "icon-menu3_screener":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconScreener, {});
            case "icon-menu3_valuation":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconValuation, {});
            case "icon-menu3_financials":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFinancials, {});
            case "icon-menu3_fundachart":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFundachart, {});
            case "icon-menu3_seasonality":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSeasonality, {});
            case "icon-menu3_sector":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSector, {});
            case "icon-menu3_calendar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalender, {});
            case "icon-menu3_earning":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEarnings, {});
            case "icon-menu3_glossary":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGlossary, {});
            case "icon-menu3_ebook":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEBook, {});
            default:
                return null;
        }
    };
    var handleHref = function(item) {
        switch(item){
            case "/securities/portfolio":
                if (tradingType) {
                    return "/securities/portfolio";
                }
                if (router.pathname === "/[username]") {
                    return "".concat(data === null || data === void 0 ? void 0 : data.username);
                }
                return router.asPath;
            default:
                return item;
        }
    };
    // Handle Redirection After Login
    (0,react.useEffect)(function() {
        if (tradingType === "real" || tradingType === "virtual") {
            if ((tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.redirectURL) === "/securities/portfolio") {
                closeAuthModal();
                router.push(tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.redirectURL);
            }
        }
    }, [
        tradingType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: navbarRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarWeb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
            minimize: minimize,
            expandNavLogo: renderExpand,
            isSideWidgetOpen: true,
            children: navbar(data).map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                    active: item.matcher(router),
                    "data-cy": item["data-cy"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar_ReloadHandler, {
                        href: handleHref(item.href),
                        label: item.label,
                        onClick: function() {
                            try {
                                (0,clevertap/* clevertapEvent */.Lq)(constants_clevertap/* CLEVERTAP_EVENT_NAME.HEADER_MENU */.dR.HEADER_MENU, {
                                    Action: item.label.toLowerCase()
                                });
                            } catch (e) {
                                ;
                            }
                            if (item.label === "Portfolio") {
                                if (tradingType) {
                                    router.push(item.href);
                                } else {
                                    showAuthModal({
                                        redirectURL: "/securities/portfolio",
                                        isRedirect: true
                                    });
                                }
                            }
                        },
                        isMobile: false,
                        children: [
                            renderIcon(item.logoMobile),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: "a",
                                color: "inherit",
                                pl: "6px",
                                children: item.label
                            })
                        ]
                    })
                }, item.label);
            })
        }))
    });
};
Web.propTypes = {
    minimize: (prop_types_default()).bool
};
Web.defaultProps = {
    minimize: false
};
/* harmony default export */ var Navbar_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/Navbar/index.jsx




/***/ }),

/***/ 25045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Notification_Mobile; },
  "p": function() { return /* reexport */ Notification_Web; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/global/Header/Notification/context.tsx


// @ts-ignore
var NotificationContext = /*#__PURE__*/ (0,react.createContext)();
var NotificationProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)("notification"), tab = ref[0], setTab = ref[1];
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)({
        visible: false,
        id: 0
    }), modalConvo = ref2[0], setModalConvo = ref2[1];
    var toggleNotification = function() {
        setVisible(!visible);
    };
    var closeNotification = function() {
        setVisible(false);
    };
    var changeTab = function(tabName) {
        setTab(tabName);
    };
    var showConvo = function(val) {
        setModalConvo(val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationContext.Provider, {
        value: {
            tab: tab,
            visible: visible,
            modalConvo: modalConvo,
            changeTab: changeTab,
            toggleNotification: toggleNotification,
            closeNotification: closeNotification,
            showConvo: showConvo
        },
        children: children
    });
};

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/lib/entities/notification/useNotificationData.ts
var useNotificationData = __webpack_require__(89790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconNotif.tsx


function IconNotif() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5625 23.8767C17.009 24.707 16.066 25.2502 15 25.2502C13.934 25.2502 12.991 24.707 12.4375 23.8767",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.25 21.15H4.75C4.75 21.15 7.825 17.5625 7.825 11.925C7.825 7.95825 11.0332 4.75 15 4.75C16.9885 4.75 18.772 5.5495 20.0738 6.85125C21.3755 8.14275 22.175 9.94675 22.175 11.925C22.175 17.5625 25.25 21.15 25.25 21.15Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/header/index.js + 2 modules
var header = __webpack_require__(37944);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/global/Header/Notification/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 15px;\n  border-top: 1px solid ",
        ";\n  background: ",
        ";\n  :hover {\n    background: ",
        ";\n  }\n\n  @media ",
        " {\n    :last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 12px;\n  width: calc(100% - 20px);\n  & > p {\n    position: relative;\n    text-overflow: ellipsis;\n    word-wrap: break-word;\n    overflow: hidden;\n    line-height: 1.4em;\n    word-break: break-word;\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: none;\n  overflow-y: auto;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 324px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .load-button {\n    border-right: 0;\n    border-left: 0;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  @media only screen and (max-width: 767px) {\n    .load-button {\n      border-top: none;\n      border-radius: 0;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .load-button {\n    border-top: none;\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 13px;\n  margin-top: 15px;\n  width: 80%;\n\n  * {\n    border-collapse: collapse;\n  }\n\n  .ant-radio:hover .ant-radio-inner {\n    border-color: ",
        ";\n  }\n\n  .ant-radio-checked::after {\n    content: unset;\n  }\n\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: unset;\n  }\n\n  .ant-radio-button-wrapper {\n    align-items: center;\n    border-width: 0.8px;\n    border-color: ",
        ";\n    color: ",
        ";\n    display: flex;\n    font-family: 'ProximaNovaRg', sans-serif;\n    font-size: 12px;\n    height: 28px;\n    justify-content: center;\n    width: calc(100% / 3);\n    padding: 0px 10px;\n\n    &:first-child {\n      border-top-left-radius: 2px;\n      border-bottom-left-radius: 2px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 2px;\n      border-bottom-right-radius: 2px;\n    }\n  }\n\n  .ant-radio-button-wrapper + .ant-radio-button-wrapper {\n    margin-left: -1px;\n  }\n\n  .ant-radio-button-wrapper:hover {\n    color: unset;\n    background: unset;\n  }\n\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    color: ",
        ";\n    background: ",
        ";\n    border-color: ",
        " !important;\n    box-shadow: unset;\n  }\n\n  .ant-radio-button-wrapper:not(:first-child)::before {\n    content: unset;\n  }\n\n  span {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  padding: 0px;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 5%;\n  left: 5%;\n  min-width: 18px;\n  height: 18px;\n  line-height: 18px;\n  padding: 0 2px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  font-size: 11px;\n  color: ",
        ";\n  text-align: center;\n  border: 1px solid #8f8f8f;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    background-color: transparent;\n    width: 18px;\n    height: 18px;\n    border: none;\n    border-radius: 0%;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    left: -200px;\n    width: 30%;\n  }\n  50% {\n    width: 30%;\n  }\n  70% {\n    width: 70%;\n  }\n  80% {\n    left: 50%;\n  }\n  95% {\n    left: 120%;\n  }\n  to {\n    left: 100%;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #dadada;\n  display: ",
        ";\n\n  :before {\n    display: block;\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: ",
        " 2s linear infinite;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  background: #f2f1fe;\n  border-radius: 100%;\n\n  svg {\n    height: 16px;\n    width: 16px;\n    color: #8277f8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}









var RadioGroup = es_radio/* default.Group */.ZP.Group;
var NotifListContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function(props) {
    return {
        // @ts-expect-error
        isNew: props.isNew
    };
}).withConfig({
    componentId: "sc-33051c7d-0"
})(_templateObject(), color/* default.whisper */.Z.whisper, function(param) {
    var isNew = param.isNew;
    return isNew ? color/* default.downgray */.Z.downgray : color/* default.light */.Z.light;
}, color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet);
var NotifListContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33051c7d-1"
})(_templateObject1());
var CustomPopoverContainer = (0,styled_components_browser_esm/* default */.ZP)(header/* PopoverContainer */.OI).withConfig({
    componentId: "sc-33051c7d-2"
})(_templateObject2(), color/* default.light */.Z.light);
var PopoverContentMobile = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContent */.yk).withConfig({
    componentId: "sc-33051c7d-3"
})(_templateObject3(), color/* default.gainsboro */.Z.gainsboro);
var PopoverContentWeb = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContent */.yk).withConfig({
    componentId: "sc-33051c7d-4"
})(_templateObject4());
var PopoverFooterWeb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33051c7d-5"
})(_templateObject5());
var PopoverFooterMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33051c7d-6"
})(_templateObject6());
var ButtonGroup = (0,styled_components_browser_esm/* default */.ZP)(RadioGroup).attrs({
    optionType: "button"
}).withConfig({
    componentId: "sc-33051c7d-7"
})(_templateObject7(), color/* default.gainsboro */.Z.gainsboro, color/* default.lowgray */.Z.lowgray, color/* default.midgray */.Z.midgray, color/* default.primary */.Z.primary, color/* default.light */.Z.light, color/* default.primary */.Z.primary);
var CloseButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-33051c7d-8"
})(_templateObject8(), color/* default.suvaGrey */.Z.suvaGrey);
var NotificationCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-33051c7d-9"
})(_templateObject9(), color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var IconContainer = (0,styled_components_browser_esm/* default */.ZP)(Avatar/* default */.Z).withConfig({
    componentId: "sc-33051c7d-10"
})(_templateObject10());
var LineAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject11());
var LineLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33051c7d-11"
})(_templateObject12(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "block" : "none";
}, LineAnimation);
var DayTradeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-33051c7d-12"
})(_templateObject13());


;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationIcon.tsx
/* eslint-disable react/destructuring-assignment */ 





var NotificationIcon = function(iconProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Iconmoon/* IconWrapper */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
        size: "40px",
        style: {
            marginRight: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: "#969696",
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNotif, {})
            }),
            iconProps.count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCount, {
                children: iconProps.count > 99 ? "99+" : iconProps.count
            })
        ]
    }));
};
/* harmony default export */ var Notification_NotificationIcon = (NotificationIcon);

// EXTERNAL MODULE: ./src/utils/notification.ts
var notification = __webpack_require__(25178);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationTitle.tsx






function NotificationTitle(param) {
    var tab = param.tab, onClickBack = param.onClickBack;
    var TAB = (0,general/* capitalizeFirstLetter */.fm)(tab);
    if (tab !== "notification") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                    // @ts-expect-error
                    margin: "0 0 0 -16px",
                    onClick: onClickBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                        size: "30px",
                        className: "icon-notification_back"
                    })
                }, "icon-notification_back"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    size: "16px",
                    "data-cy": "".concat(data_cy/* default.NOTIFICATION.TITLE_TEXT */.Z.NOTIFICATION.TITLE_TEXT, "-").concat(TAB),
                    children: TAB
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        family: "bold",
        size: "16px",
        "data-cy": "".concat(data_cy/* default.NOTIFICATION.TITLE_TEXT */.Z.NOTIFICATION.TITLE_TEXT, "-Notification"),
        children: TAB
    });
}
/* harmony default export */ var Notification_NotificationTitle = (NotificationTitle);

// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationTab.tsx







function NotificationTab(param) {
    var list = param.list, type = param.type;
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var changeTab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.changeTab;
    });
    var onClickTab = function(tabName) {
        return function() {
            changeTab(tabName);
        };
    };
    if (type === "text") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
            value: tab,
            children: list.map(function(param) {
                var name = param.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default.Button */.ZP.Button, {
                    value: name,
                    onClick: onClickTab(name),
                    checked: tab === name,
                    children: (0,general/* capitalizeFirstLetter */.fm)(name)
                }, "tab-".concat(tab));
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: list.map(function(param) {
            var className = param.className, name = param.name;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "30px",
                onClick: onClickTab(name),
                children: tab === name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-".concat(name, "-active.svg")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-".concat(name, ".svg")
                })
            }, className);
        })
    });
}
/* harmony default export */ var Notification_NotificationTab = (NotificationTab);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationHeader.tsx








function NotificationHeader(param) {
    var device = param.device;
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var changeTab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.changeTab;
    });
    var isMobileDevice = device === "mobile";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineLoader, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverTitleWrapper */.xK, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        align: "center",
                        justify: "space-between",
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTitle, {
                            tab: tab,
                            onClickBack: function() {
                                return changeTab("notification");
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            !isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTab, {
                                list: notification/* notificationTabsAttrs */.jg,
                                type: "icon"
                            }),
                            isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                onClick: closePopup,
                                children: "Close"
                            })
                        ]
                    })
                ]
            }),
            isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTab, {
                    list: notification/* notificationTabsAttrs */.jg,
                    type: "text"
                })
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationHeader = (NotificationHeader);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationFooter.tsx





function NotificationFooter() {
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var lastId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].lastId;
    });
    var total = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].list.length;
    });
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var isLoadingPrevious = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoadingPrevious;
    });
    var getPrevNotification = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getPrevNotification;
    });
    var handlePrevClick = function() {
        getPrevNotification(tab, lastId);
    };
    if (isLoading && total === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: "load-button",
        block: true,
        height: "36px",
        onClick: handlePrevClick,
        loading: isLoadingPrevious,
        children: !isLoadingPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: color/* default.primary */.Z.primary,
            align: "center",
            children: "Load Previous"
        })
    });
}
/* harmony default export */ var Notification_NotificationFooter = (NotificationFooter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Header/Search/options.tsx
var options = __webpack_require__(31706);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItemImage.tsx









function NotificationItemImage(param) {
    var type = param.type, avatar = param.avatar;
    if (notification/* notificationTypesWithAvatar.includes */.UC.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(options/* CustomAvatar */.zU, {
            img: avatar,
            name: "avatar"
        });
    }
    if (notification/* notificationCategories.reports.includes */.In.reports.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                size: "x-small",
                className: "panel-avatar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-report.svg"
                })
            })
        });
    }
    if (notification/* notificationCategories.tipping.includes */.In.tipping.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: avatar,
                width: "30",
                height: "30",
                alt: "tipping"
            })
        });
    }
    if (notification/* notificationCategories.tradingMatchOrder.includes */.In.tradingMatchOrder.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
            size: "small",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                as: "a",
                size: "30px",
                className: "icon-avatar_order"
            })
        });
    }
    if (notification/* notificationCategories.trending.includes */.In.trending.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification-trending.svg",
            width: "30",
            height: "30",
            alt: "trending"
        });
    }
    if (notification/* notificationCategories.verified.includes */.In.verified.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification-approved.png",
            width: "30",
            height: "30",
            alt: "approved"
        });
    }
    if (notification/* notificationCategories.dayTrade.includes */.In.dayTrade.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayTradeWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                component: Icons/* LightningSvg */.Sf
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
        size: "small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification/icon-notif.svg"
        })
    });
}
/* harmony default export */ var Notification_NotificationItemImage = (NotificationItemImage);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItemContent.tsx










function NotificationItemContent(param) {
    var isNew = param.isNew, type = param.type, avatar = param.avatar, mask = param.mask, message = param.message, created = param.created;
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var content = (0,react.useMemo)(function() {
        var text = message;
        if (mask) {
            text = (0,notification/* parseNotificationMessage */.x8)({
                mask: mask,
                message: message,
                renderParseString: function(str) {
                    return str;
                },
                render: function(parsedText, tag) {
                    if (tag === "br") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                    }
                    if (tag === "b") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: parsedText
                        });
                    }
                    if (!parsedText) {
                        return parsedText;
                    }
                    return parsedText;
                }
            });
        }
        return text;
    }, [
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifListContainer, {
        isNew: isNew,
        onClick: closePopup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "30px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemImage, {
                    type: type,
                    avatar: avatar
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifListContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "13px",
                        children: content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "11px",
                        color: color/* default.midgray */.Z.midgray,
                        mt: "5px",
                        children: moment_default()(created).fromNow()
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationItemContent = (NotificationItemContent);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItem.tsx



function NotificationItem(param) {
    var item = param.item, onClickConversationNotif = param.onClickConversationNotif;
    var messageData = item.data;
    var type = item.type;
    var maskKey = "message_mask";
    var linkToKey = "link_to";
    var mask = messageData[maskKey] || [];
    var attrs = {
        href: "",
        onClick: null
    };
    var message = (messageData === null || messageData === void 0 ? void 0 : messageData.message) || "";
    switch(type){
        case "NOTIF_TYPE_MENTIONS":
        case "NOTIF_TYPE_NEW_REPORT":
        case "NOTIF_TYPE_LIKE":
        case "NOTIF_TYPE_STREAMS_UPDATE":
        case "NOTIF_TYPE_POSTALERT":
        case "NOTIF_TYPE_SAVE":
        case "NOTIF_TYPE_RETWEET":
        case "NOTIF_TYPE_NEWSFEED":
        case "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE":
        case "NOTIF_TYPE_COMPANY_SHAREHOLDING":
        case "NOTIF_TYPE_COMPANY_DIVIDEND":
        case "NOTIF_TYPE_COMPANY_CORP_ACTION":
        case "NOTIF_TYPE_COMPANY_OTHERS":
            attrs.href = "/post/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_REPLY":
            attrs.onClick = function() {
                return onClickConversationNotif({
                    visible: true,
                    id: messageData[linkToKey].value
                });
            };
            break;
        case "NOTIF_TYPE_FOLLOWING":
            attrs.href = "/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_TIPPING_RECEIVER":
        case "NOTIF_TYPE_TIPPING_SENDER":
        case "NOTIF_TYPE_CLAIM":
            attrs.href = "/tip/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_TRADING_MATCH_ORDER":
            attrs.href = "/trade/portofolio/";
            break;
        case "NOTIF_TYPE_TRADING_COMMUNITY":
            attrs.href = "/community/?search=".concat(messageData[linkToKey].value);
            if (!mask || mask.length <= 0) {
                message = "[%username-mask%] ".concat(message);
                mask = [
                    {
                        key: "username-mask",
                        payload: {
                            actors: [],
                            id: 0,
                            tag: "PAYLOAD_MASK_TAG_BOLD",
                            text: messageData[linkToKey].value,
                            type: "PAYLOAD_MASK_TYPE_USER"
                        }
                    }, 
                ];
            }
            break;
        case "NOTIF_TYPE_NEW_TRENDING":
            attrs.href = "/symbol/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_SECURITIES_DAY_TRADE":
        case "NOTIF_TYPE_SHARIA_STOCK_DELISTED":
            attrs.href = "/securities/portfolio";
            break;
        default:
            // NOTIF_TYPE_STOCK_ALERT => Cannot Clicked
            attrs.href = "";
            break;
    }
    if (attrs.href !== "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: attrs === null || attrs === void 0 ? void 0 : attrs.href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemContent, {
                    isNew: !item.is_read,
                    avatar: messageData === null || messageData === void 0 ? void 0 : messageData.avatar,
                    created: item === null || item === void 0 ? void 0 : item.created,
                    message: message,
                    mask: mask,
                    type: item === null || item === void 0 ? void 0 : item.type
                })
            })
        });
    }
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: attrs.onClick,
        role: "menuitem",
        tabIndex: -1,
        style: {
            cursor: attrs.onClick !== null ? "pointer" : "unset"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemContent, {
            isNew: !item.is_read,
            avatar: messageData === null || messageData === void 0 ? void 0 : messageData.avatar,
            created: item === null || item === void 0 ? void 0 : item.created,
            message: message,
            mask: mask,
            type: item === null || item === void 0 ? void 0 : item.type
        })
    }));
}
/* harmony default export */ var Notification_NotificationItem = (NotificationItem);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationList.tsx









function NotificationList() {
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var displayedList = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].list;
    });
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    var getNotification = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getNotification;
    });
    var markNotifAsRead = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.markNotifAsRead;
    });
    var getAwaitNotification = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(t) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getNotification(t);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }(), [
        tab
    ]);
    (0,react.useEffect)(function() {
        getAwaitNotification(tab);
        var timeoutId = setTimeout(function() {
            return markNotifAsRead(tab);
        }, 200);
        return function() {
            clearTimeout(timeoutId);
        };
    }, [
        tab
    ]);
    if (displayedList.length === 0 && !isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            align: "center",
            justify: "center",
            height: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: color/* default.highgray */.Z.highgray,
                children: "You do not have any notification right now"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: displayedList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItem, {
                item: item,
                onClickConversationNotif: function(param) {
                    var id = param.id, visible = param.visible;
                    setConvoOpen(id, visible);
                    closePopup();
                }
            }, "".concat(tab, "-").concat(item.id, "-").concat(displayedList.length));
        })
    });
}
/* harmony default export */ var Notification_NotificationList = (/*#__PURE__*/react.memo(NotificationList));

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationMobile.tsx









var StreamConversation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(50299), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(33082), __webpack_require__.e(67555), __webpack_require__.e(63828), __webpack_require__.e(97751), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(49234), __webpack_require__.e(76219), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(54392), __webpack_require__.e(12683), __webpack_require__.e(66933), __webpack_require__.e(41232), __webpack_require__.e(48308), __webpack_require__.e(82583), __webpack_require__.e(14467), __webpack_require__.e(28409)]).then(__webpack_require__.bind(__webpack_require__, 95621));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95621)
            ];
        }
    },
    ssr: false
});
var NotificationMobile = function() {
    var unread = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.unread;
    });
    var isConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isConvoOpen;
    });
    var isPopupOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isPopupOpen;
    });
    var convoId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.convoId;
    });
    var togglePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.togglePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                trigger: "click",
                visible: isPopupOpen,
                onVisibleChange: togglePopup,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomPopoverContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationHeader, {
                                device: "mobile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentMobile, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationList, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooterMobile, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationFooter, {})
                            })
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationIcon, {
                    count: unread,
                    "data-cy": "top-navbar-icon-notification-mobile"
                })
            }),
            isConvoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation, {
                postId: convoId,
                visible: isConvoOpen,
                activeCommentId: convoId,
                onCancel: function() {
                    return setConvoOpen(undefined, false);
                }
            })
        ]
    });
};
/* harmony default export */ var Notification_NotificationMobile = (NotificationMobile);

;// CONCATENATED MODULE: ./src/global/Header/Notification/Mobile.tsx



var Mobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationMobile, {})
    });
};
/* harmony default export */ var Notification_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationWeb.tsx









var NotificationWeb_StreamConversation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(50299), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(79931), __webpack_require__.e(35851), __webpack_require__.e(36055), __webpack_require__.e(33082), __webpack_require__.e(67555), __webpack_require__.e(63828), __webpack_require__.e(97751), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(49234), __webpack_require__.e(76219), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(54392), __webpack_require__.e(12683), __webpack_require__.e(66933), __webpack_require__.e(41232), __webpack_require__.e(48308), __webpack_require__.e(82583), __webpack_require__.e(14467), __webpack_require__.e(28409)]).then(__webpack_require__.bind(__webpack_require__, 95621));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95621)
            ];
        }
    },
    ssr: false
});
function NotificationWeb() {
    var unread = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.unread;
    });
    var isConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isConvoOpen;
    });
    var isPopupOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isPopupOpen;
    });
    var convoId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.convoId;
    });
    var togglePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.togglePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                trigger: "click",
                placement: "bottomRight",
                overlayStyle: {
                    width: "400px"
                },
                visible: isPopupOpen,
                onVisibleChange: togglePopup,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContentWrapper */.R_, {
                        style: {
                            minHeight: "136px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationHeader, {
                                device: "web"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentWeb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationList, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooterWeb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationFooter, {})
                            })
                        ]
                    });
                },
                destroyTooltipOnHide: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationIcon, {
                    count: unread,
                    "data-cy": "top-navbar-icon-notification-desktop"
                })
            }),
            isConvoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationWeb_StreamConversation, {
                postId: convoId,
                visible: isConvoOpen,
                activeCommentId: convoId,
                onCancel: function() {
                    return setConvoOpen(undefined, false);
                }
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationWeb = (NotificationWeb);

;// CONCATENATED MODULE: ./src/global/Header/Notification/Web.tsx



function Web() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationWeb, {})
    });
}
/* harmony default export */ var Notification_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/Notification/index.tsx




/***/ }),

/***/ 97513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ ProfileMenu_Mobile; },
  "p": function() { return /* reexport */ ProfileMenu_Web; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/@deprecated-ui/header/index.js + 2 modules
var header = __webpack_require__(37944);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/global/Header/Search/options.tsx
var options = __webpack_require__(31706);
;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/IconProfile.jsx







var IconProfile = function(_param) /*#__PURE__*/ {
    var img = _param.img, name = _param.name, iconProps = (0,_object_without_properties/* default */.Z)(_param, [
        "img",
        "name"
    ]);
    return (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
        size: "40px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(options/* CustomAvatar */.zU, {
            img: img,
            name: name
        })
    }));
};
IconProfile.propTypes = {
    img: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProfileMenu_IconProfile = (IconProfile);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/MenuProfileTitle.jsx




var MenuProfileTitle = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* PopoverTitleWrapper */.xK, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            family: "bold",
            size: "16px",
            color: "#000000A6",
            children: name
        })
    });
};
MenuProfileTitle.propTypes = {
    name: (prop_types_default()).string
};
MenuProfileTitle.defaultProps = {
    name: ""
};
/* harmony default export */ var ProfileMenu_MenuProfileTitle = (MenuProfileTitle);

// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/js-base64/base64.mjs
var js_base64_base64 = __webpack_require__(52300);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: unset;\n  border: none;\n  background-color: white;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 34px;\n  height: 16px;\n  padding: 3px 4px 3px 4px;\n  border-radius: 4px;\n  gap: 10px;\n  border: 1px solid rgba(0, 171, 107, 1);\n  color: rgba(0, 171, 107, 1);\n  font-size: 11px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  padding: 0 10px;\n  cursor: pointer;\n  color: #969696;\n  & > p {\n    padding-left: 8px;\n  }\n\n  @media ",
        " {\n    & > p {\n      padding-left: 0;\n    }\n  }\n\n  :hover {\n    color: #00ab6b;\n    background: ",
        ";\n    p,\n    p::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding: 8px 0;\n  :last-child {\n    border-bottom: none;\n    padding-bottom: 4px;\n    padding-top: 2px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 30px;\n  width: 30px;\n  align-items: center;\n  justify-content: center;\n  img {\n    height: 18px;\n    width: 18px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var CustomPopoverContainer = (0,styled_components_browser_esm/* default */.ZP)(header/* PopoverContainer */.OI).withConfig({
    componentId: "sc-7f850266-0"
})(_templateObject());
var PopoverContentMobile = (0,styled_components_browser_esm/* default */.ZP)(Popover/* PopoverContent */.yk).withConfig({
    componentId: "sc-7f850266-1"
})(_templateObject1());
var NewTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7f850266-2"
})(_templateObject2());
var MenuList = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7f850266-3"
})(_templateObject3(), device/* default.tablet */.Z.tablet, color/* default.downgray */.Z.downgray, color/* default.primary */.Z.primary);
var MenuListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f850266-4"
})(_templateObject4(), color/* default.lowgray */.Z.lowgray);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f850266-5"
})(_templateObject5());


// EXTERNAL MODULE: ./src/features/community/analytics.ts
var analytics = __webpack_require__(20826);
// EXTERNAL MODULE: ./src/features/user/analytics/ProfileAnalytics.ts
var ProfileAnalytics = __webpack_require__(63576);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
;// CONCATENATED MODULE: ./src/utils/user.jsx










// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64_base64/* Base64.encode */.DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64_base64/* Base64.decode */.DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
// Save user credentials to local storage
var setLocalUser = function(accessUser) {
    return saveObject("au", accessUser);
};
var setLocalAccess = function(accessToken) {
    return saveObject("at", accessToken);
};
var setLocalAccessExp = function(accessTokenExp) {
    return saveObject("ate", accessTokenExp);
};
var setLocalRefresh = function(refreshToken) {
    return saveObject("ar", refreshToken);
};
var setLocalRefreshExp = function(refreshTokenExp) {
    return saveObject("are", refreshTokenExp);
};
var setLocalChatToken = function(wsToken) {
    return saveObject("wst", wsToken);
};
var setLocalIntercomSettings = function(intercom) {
    return saveObject("icom", intercom);
};
var setLocalCrispSettings = function(crisp) {
    return saveObject("crisp", crisp);
};
var setLocalTempUserKey = function(tempUserKey) {
    return saveObject("tmpkey", tempUserKey);
};
var pageSourceIndex = ProfileAnalytics/* PAGE_SOURCE_INDEX.findIndex */.en.findIndex(function(sourceIndex) {
    return sourceIndex === "My Profile";
});
var getOS = function() {
    if (!(0,app/* isClient */.C5)()) {
        return "others";
    }
    var userAgent = navigator.userAgent;
    if (/Windows/.test(userAgent)) {
        return "Windows";
    }
    if (/Mac OS|Macintosh/.test(userAgent)) {
        return "macOS";
    }
    return "others";
};
// Build user profile menu
var profileMenu = function(data) {
    if (!data) {
        return [];
    }
    var proText = data.ispro ? "Extend PRO Subscription" : "Upgrade to PRO";
    // Countries that will not implement pro features
    var noProCountries = [
        "MY",
        "SG"
    ];
    // Countries that will implement some features
    var implementCountries = [
        "ID"
    ];
    var isTipJarMenuItemAvailable = implementCountries.some(function(country) {
        return data.country === country;
    });
    var isProAvailable = !noProCountries.some(function(country) {
        return data.country === country;
    });
    var tipJarMenuItem = isTipJarMenuItemAvailable ? [
        {
            label: "My Tip Jar",
            logo: "icon-setting_tipjar",
            url: "/tipjar"
        }
    ] : [];
    var communityItem = data.isCommunityAccessGranted && data.country === "ID" ? [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                style: {
                    gap: 5
                },
                onClick: function() {
                    analytics/* affiliateActions.externalCommunitySelected */.d.externalCommunitySelected();
                },
                children: [
                    "External Community ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewTag, {
                        children: "New"
                    })
                ]
            }),
            url: "/community",
            logo: "icon-community"
        }, 
    ] : [];
    var menuItemGroup1 = [
        {
            label: "My Profile",
            logo: "icon-menu_profile",
            url: "/".concat(data.username, "?source=").concat(pageSourceIndex)
        },
        {
            label: "Settings",
            logo: "icon-menu_setting",
            url: "/profile/edit"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(communityItem), (0,_to_consumable_array/* default */.Z)(tipJarMenuItem));
    var proItems = [
        {
            label: proText,
            logo: "icon-setting_subscribe",
            url: "/shop"
        }, 
    ];
    var menuItemGroup2 = isProAvailable ? proItems : undefined;
    var menuItemGroup3 = [
        {
            label: "Rules",
            logo: "icon-setting_rules",
            url: "/rules"
        },
        {
            label: "Help",
            logo: "icon-setting_help",
            url: "https://help.stockbit.com"
        },
        {
            label: "Live Support",
            logo: "icon-setting_support",
            url: "",
            onClick: function(e) {
                e.preventDefault();
                (0,crisp/* handleClickSupport */.lA)();
            }
        },
        {
            label: "Logout",
            logo: "icon-setting_logout",
            url: "/logout"
        }, 
    ];
    var menuDownload = [
        {
            type: "download",
            label: "Download Desktop App",
            image: "/images/download-icon.svg",
            textColor: color/* default.primary */.Z.primary,
            url: "",
            onClick: function(e) {
                e.preventDefault();
            }
        }, 
    ];
    return [
        menuItemGroup1,
        menuItemGroup2,
        menuItemGroup3,
        menuDownload
    ].filter(function(menuItemGroup) {
        return menuItemGroup !== undefined;
    });
};
/* harmony default export */ var user = ({
    setLocalUser: setLocalUser,
    setLocalAccess: setLocalAccess,
    setLocalAccessExp: setLocalAccessExp,
    setLocalRefresh: setLocalRefresh,
    setLocalRefreshExp: setLocalRefreshExp,
    setLocalChatToken: setLocalChatToken,
    setLocalIntercomSettings: setLocalIntercomSettings,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalTempUserKey: setLocalTempUserKey,
    encodeBase64FromJS: encodeBase64FromJS,
    decodeBase64ToJS: decodeBase64ToJS,
    profileMenu: profileMenu,
    getOS: getOS
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/hooks/useDownloadDesktopApp.ts
var useDownloadDesktopApp = __webpack_require__(85557);
// EXTERNAL MODULE: ./src/features/download/desktop-analytics.ts
var desktop_analytics = __webpack_require__(53400);
;// CONCATENATED MODULE: ./src/assets/customIcon/IconMenuProfile.tsx


function IconMenuProfile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 9.875H6.08333C4.79417 9.875 3.75 10.9192 3.75 12.2083V13.375C3.75 14.0167 4.275 14.5417 4.91667 14.5417H13.0833C13.725 14.5417 14.25 14.0167 14.25 13.375V12.2083C14.25 10.9192 13.2058 9.875 11.9167 9.875H9Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 8.12501C10.2887 8.12501 11.3333 7.08034 11.3333 5.79168C11.3333 4.50301 10.2887 3.45834 9 3.45834C7.71133 3.45834 6.66666 4.50301 6.66666 5.79168C6.66666 7.08034 7.71133 8.12501 9 8.12501Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingSubscribe.tsx


function IconSettingSubsribe() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0749 6.24086C14.0749 7.85086 12.7682 9.15752 11.1582 9.15752C9.54823 9.15752 8.24156 7.85086 8.24156 6.24086C8.24156 4.63085 9.54823 3.32419 11.1582 3.32419C12.7682 3.32419 14.0749 4.63085 14.0749 6.24086Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.09323 8.30017L3.5749 13.8243",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.52567 12.8677L5.354 13.6961",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.76823 11.6309L6.59073 12.4534",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingRules.tsx


function IconSettingRules() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_652_327)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 14.833C12.2217 14.833 14.8333 12.2214 14.8333 8.99972C14.8333 5.77805 12.2217 3.16638 9 3.16638C5.77834 3.16638 3.16666 5.77805 3.16666 8.99972C3.16666 12.2214 5.77834 14.833 9 14.833Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.99992 7.54108V11.6244",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.83326 11.6244H10.1666",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.4166 7.54108H8.99993",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.83743 6.08275C8.83743 6.08156 8.83779 6.07891 8.83898 6.07608C8.84001 6.07365 8.84124 6.07204 8.84231 6.07097C8.84338 6.0699 8.84499 6.06867 8.84742 6.06764C8.85025 6.06645 8.8529 6.06609 8.85409 6.06609C8.85529 6.06609 8.85794 6.06645 8.86076 6.06764C8.86319 6.06867 8.86481 6.0699 8.86588 6.07097C8.86695 6.07204 8.86818 6.07365 8.8692 6.07608C8.8704 6.07891 8.87076 6.08156 8.87076 6.08275C8.87076 6.08395 8.8704 6.0866 8.8692 6.08943C8.86818 6.09185 8.86695 6.09347 8.86588 6.09454C8.86481 6.09561 8.86319 6.09684 8.86076 6.09786C8.85794 6.09906 8.85529 6.09942 8.85409 6.09942C8.8529 6.09942 8.85025 6.09906 8.84742 6.09786C8.84499 6.09684 8.84338 6.09561 8.84231 6.09454C8.84124 6.09347 8.84001 6.09185 8.83898 6.08943C8.83779 6.0866 8.83743 6.08395 8.83743 6.08275Z",
                        fill: "currentColor",
                        stroke: "currentColor",
                        strokeWidth: "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_327",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/assets/customIcon/IconSettingSupport.tsx
var IconSettingSupport = __webpack_require__(10699);
;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingLogout.tsx


function IconSettingLogout() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.1667 14.8336H4.91667C4.59584 14.8336 4.33334 14.5711 4.33334 14.2503V3.75028C4.33334 3.42945 4.59584 3.16695 4.91667 3.16695H10.1667",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.83334 9.00029H14.8333",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 6.20029L14.8333 9.00029L12.5 11.8003",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconMenuSetting.tsx


function IconMenuSetting() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_652_290)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 11.333C10.2887 11.333 11.3333 10.2884 11.3333 8.99972C11.3333 7.71105 10.2887 6.66638 9 6.66638C7.71133 6.66638 6.66666 7.71105 6.66666 8.99972C6.66666 10.2884 7.71133 11.333 9 11.333Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.5855 9.43528L14.4695 10.3193C14.666 10.5158 14.709 10.8227 14.5678 11.0622L13.5671 12.7934C13.4259 13.0329 13.1435 13.1495 12.8795 13.082L11.6762 12.7627C11.3508 12.6768 11.0132 12.8671 10.9272 13.1986L10.608 14.4019C10.5343 14.672 10.2949 14.8562 10.0125 14.8562H8.01107C7.7348 14.8562 7.48924 14.672 7.41557 14.4019L7.09633 13.1986C7.01038 12.8732 6.67272 12.6768 6.34734 12.7627L5.14405 13.082C4.87393 13.1556 4.59152 13.039 4.45646 12.7934L3.45577 11.0622C3.31456 10.8227 3.35754 10.5158 3.55399 10.3193L4.43804 9.43528C4.67747 9.19585 4.67747 8.80908 4.43804 8.56965L3.55399 7.6856C3.35754 7.48914 3.31456 7.18218 3.45577 6.94275L4.45646 5.21149C4.59766 4.97206 4.88007 4.85542 5.14405 4.92295L6.34734 5.24219C6.67272 5.32814 7.01038 5.13782 7.09633 4.8063L7.41557 3.60301C7.48924 3.33289 7.72867 3.14871 8.01107 3.14871H10.0125C10.2887 3.14871 10.5343 3.33289 10.608 3.60301L10.9272 4.8063C11.0132 5.13168 11.3508 5.32814 11.6762 5.24219L12.8795 4.92295C13.1496 4.84928 13.432 4.96592 13.5671 5.21149L14.5678 6.94275C14.709 7.18218 14.666 7.48914 14.4695 7.6856L13.5855 8.56965C13.3461 8.80908 13.3461 9.19585 13.5855 9.43528Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_290",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingTipjar.tsx


function IconSettingTipjar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 14.8336H5.5C4.85834 14.8336 4.33334 14.3086 4.33334 13.6669V9.19856C4.33334 8.69106 4.49667 8.20106 4.8 7.79856L6.08334 6.0894V4.92273H5.49417C5.17334 4.92273 4.91667 4.6544 4.91667 4.33356V3.75606C4.91667 3.43523 5.17917 3.17273 5.5 3.17273H12.5C12.8208 3.17273 13.0833 3.43523 13.0833 3.75606V4.33356C13.0833 4.6544 12.8267 4.9169 12.5058 4.9169H11.9167V6.0894L13.2 7.79856C13.5033 8.20106 13.6667 8.69106 13.6667 9.19856V13.6669C13.6667 14.3086 13.1417 14.8336 12.5 14.8336Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.08334 4.91666H11.9167",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 7.83334V12.5",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4583 8.41666H8.41666C7.9325 8.41666 7.54166 8.80749 7.54166 9.29166C7.54166 9.77582 7.9325 10.1667 8.41666 10.1667H9.58333C10.0675 10.1667 10.4583 10.5575 10.4583 11.0417C10.4583 11.5258 10.0675 11.9167 9.58333 11.9167H7.54166",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconCommunity.tsx


function IconCommunity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66666 12.5003L4.33333 14.2503V12.5003H4.32166C3.68 12.5003 3.16666 11.9753 3.16666 11.3336V5.50028C3.16666 4.85862 3.69166 4.33362 4.33333 4.33362H13.6667C14.3083 4.33362 14.8333 4.85862 14.8333 5.50028V9.00029",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 10.5575H9.39084C8.53334 10.5575 7.83334 11.2516 7.83334 12.115V12.8908C7.83334 13.3225 8.18334 13.6666 8.60917 13.6666H14.0517C14.4833 13.6666 14.8275 13.3166 14.8275 12.8908V12.115C14.8275 11.2575 14.1333 10.5575 13.27 10.5575H11.3275H11.3333Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 9.39079C12.1935 9.39079 12.8908 8.69347 12.8908 7.83329C12.8908 6.9731 12.1935 6.27579 11.3333 6.27579C10.4731 6.27579 9.77583 6.9731 9.77583 7.83329C9.77583 8.69347 10.4731 9.39079 11.3333 9.39079Z",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.41666 9.00027L6.66666 7.25027",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 10.5581V11.9173",
                stroke: "currentColor",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingHelp.tsx


function IconSettingHelp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_652_337)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 14.8333C12.2217 14.8333 14.8333 12.2217 14.8333 8.99999C14.8333 5.77833 12.2217 3.16666 9 3.16666C5.77834 3.16666 3.16666 5.77833 3.16666 8.99999C3.16666 12.2217 5.77834 14.8333 9 14.8333Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 11.9167C10.6108 11.9167 11.9167 10.6108 11.9167 9.00001C11.9167 7.38918 10.6108 6.08334 9 6.08334C7.38917 6.08334 6.08334 7.38918 6.08334 9.00001C6.08334 10.6108 7.38917 11.9167 9 11.9167Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.1242 4.87564L11.065 6.93481",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.87583 4.87564L6.935 6.93481",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.87583 13.1242L6.935 11.065",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.1242 13.1242L11.065 11.065",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_337",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/ProfileMenuReactNode.jsx






















var MenuListWithRef = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var href = param.href, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        onClick: onClick,
        ref: ref,
        children: children
    });
});
MenuListWithRef.propTypes = {
    href: (prop_types_default()).string,
    onClick: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).node.isRequired
};
MenuListWithRef.defaultProps = {
    href: ""
};
var ProfileMenuReactNode = function(data) {
    var download = (0,useDownloadDesktopApp/* default */.Z)().download;
    var router = (0,next_router.useRouter)();
    var getStyleMenuList = function(index) {
        if (index === 3) return {
            borderBottom: "none"
        };
        return {};
    };
    var onClickItem = function(e, item) {
        if (item.type === "download") {
            e.preventDefault();
            var os = user.getOS();
            var analyticOS = os === "macOS" ? "Mac" : os;
            if (os === "macOS" || os === "Windows") {
                desktop_analytics/* DesktopAppDownloadAnalytics.onDownloadDesktopApp */.E.onDownloadDesktopApp({
                    os: analyticOS,
                    source: "Dropdown Profile"
                });
                download(os.toLowerCase());
                var el = document.getElementById("icon-profile-popover");
                el.click();
            } else {
                router.push("/desktop");
            }
        } else if (item.onClick) item.onClick(e);
    };
    var getSystemRequirementWording = function() {
        var os = user.getOS();
        if (os === "macOS") return "For MacOS 12 or above";
        if (os === "Windows") return "For Windows 10 or above";
        return "";
    };
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-menu_profile":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuProfile, {});
            case "icon-menu_setting":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuSetting, {});
            case "icon-setting_tipjar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingTipjar, {});
            case "icon-community":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCommunity, {});
            case "icon-setting_subscribe":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingSubsribe, {});
            case "icon-setting_rules":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingRules, {});
            case "icon-setting_help":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingHelp, {});
            case "icon-setting_support":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingSupport/* default */.Z, {});
            case "icon-setting_logout":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingLogout, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuProfile, {});
        }
    };
    return user.profileMenu(data).map(function(menu, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListContainer, {
            style: getStyleMenuList(index),
            children: menu.map(function(item) {
                var label = item.label, logo = item.logo, url = item.url, image = item.image, textColor = item.textColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListWithRef, {
                        href: url,
                        onClick: function(e) {
                            onClickItem(e, item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList, {
                            children: [
                                logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                    size: "30px",
                                    children: renderIcon(logo)
                                }),
                                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        alt: "",
                                        src: image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "14px",
                                            color: textColor || color/* default.highempahis */.Z.highempahis,
                                            children: label
                                        }),
                                        item.type === "download" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                color: "#858585",
                                                fontSize: 11
                                            },
                                            children: getSystemRequirementWording()
                                        })
                                    ]
                                })
                            ]
                        }, label)
                    })
                }, label);
            })
        }, "menu-list-".concat(index + 1));
    });
};
/* harmony default export */ var ProfileMenu_ProfileMenuReactNode = (ProfileMenuReactNode);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/Mobile.jsx











var Mobile = function() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var remisier = (0,useUIConfigStore/* default */.Z)(function(store) {
        return store.getUIValue("remisier");
    });
    var adjustedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        isCommunityAccessGranted: remisier === null || remisier === void 0 ? void 0 : remisier.isCommunityAccessGranted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* PopoverCustom */.Bp, {
        componentTrigger: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_IconProfile, {
                img: data.avatar,
                name: data.username,
                "data-cy": "top-navbar-icon-profile-mobile"
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomPopoverContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_MenuProfileTitle, {
                    name: data.username
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentMobile, {
                    children: ProfileMenu_ProfileMenuReactNode(adjustedData)
                })
            ]
        })
    });
};
/* harmony default export */ var ProfileMenu_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/Web.jsx










var Web = function() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var remisier = (0,useUIConfigStore/* default */.Z)(function(store) {
        return store.getUIValue("remisier");
    });
    var adjustedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        isCommunityAccessGranted: remisier === null || remisier === void 0 ? void 0 : remisier.isCommunityAccessGranted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
        trigger: "click",
        placement: "bottomRight",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContentWrapper */.R_, {
                style: {
                    maxHeight: 500
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_MenuProfileTitle, {
                        name: data.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* PopoverContent */.yk, {
                        style: {
                            maxHeight: 500
                        },
                        children: ProfileMenu_ProfileMenuReactNode(adjustedData)
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_IconProfile, {
            id: "icon-profile-popover",
            img: data.avatar,
            name: data.username,
            "data-cy": "top-navbar-icon-profile-desktop"
        })
    });
};
/* harmony default export */ var ProfileMenu_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/index.jsx




/***/ }),

/***/ 87671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RealTrading_Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/features/securities/hooks/useSecuritiesButton.ts
var useSecuritiesButton = __webpack_require__(45173);
// EXTERNAL MODULE: ./src/global/Header/RealTrading/realTadingMenu.tsx
var realTadingMenu = __webpack_require__(38097);
// EXTERNAL MODULE: ./src/global/Header/RealTrading/styled.ts
var styled = __webpack_require__(39971);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Mobile.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #00ab6b !important;\n  border: 1px solid #00ab6b !important;\n  border-radius: 4px;\n  width: 100%;\n\n  padding: 4px 15px;\n  margin: 16px 0 0;\n  height: 36px;\n  font-weight: bold;\n  color: #ffffff !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BuyButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5cd8f105-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconOrderbook.tsx
var IconOrderbook = __webpack_require__(10714);
// EXTERNAL MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconPortfolio.tsx
var IconPortfolio = __webpack_require__(40261);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconOrder.tsx


function IconOrder() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0723 5.28516L19.1248 8.33766L16.1248 11.3377",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.125 8.33789H6.375",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.6775 12.793L5.625 15.8455L8.625 18.8455",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.625 15.8457H18.375",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconHistory.tsx


function IconHistory() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33350)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.125 8.31445V12.0645L15.125 14.3145",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.0727 7.63867H6.0727L6.0127 4.63867",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.07227 7.63868C8.51727 4.29368 13.2048 3.56618 16.5498 6.01118C19.8948 8.45618 20.6223 13.1512 18.1773 16.4887C15.7323 19.8337 11.0373 20.5612 7.69977 18.1162",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.69984 18.1179C6.14734 16.9854 5.02984 15.2604 4.71484 13.2129",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33350",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.125 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconDeposit.tsx


function IconDeposit() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33359)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.625 13.9395V15.8145C19.625 16.6395 18.95 17.3145 18.125 17.3145H7.625C6.8 17.3145 6.125 16.6395 6.125 15.8145V8.31445C6.125 7.48195 6.8 6.81445 7.625 6.81445H18.125C18.95 6.81445 19.625 7.48195 19.625 8.31445V10.1895",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.375 10.1895H20.375V13.9395H17.375C16.55 13.9395 15.875 13.2645 15.875 12.4395V11.6895C15.875 10.8645 16.55 10.1895 17.375 10.1895Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.63477 6.81492L11.8098 4.63992C12.4023 4.05492 13.3473 4.05492 13.9323 4.63992L16.1148 6.82242",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33359",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.875 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconWitdrawal.tsx


function IconWitdrawal() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.625 16.5645H6.625C5.8 16.5645 5.125 15.8895 5.125 15.0645V9.06445C5.125 8.23945 5.8 7.56445 6.625 7.56445H18.625C19.45 7.56445 20.125 8.23945 20.125 9.06445V15.0645C20.125 15.8895 19.45 16.5645 18.625 16.5645H15.625",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.625 14.3145C13.8676 14.3145 14.875 13.3071 14.875 12.0645C14.875 10.8218 13.8676 9.81445 12.625 9.81445C11.3824 9.81445 10.375 10.8218 10.375 12.0645C10.375 13.3071 11.3824 14.3145 12.625 14.3145Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.625 16.3145V20.0645",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.125 18.5645L12.625 20.0645L14.125 18.5645",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconSecurity.tsx


function IconSecurity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.5 19.1366L7.9 19.1741L9.67 17.4041H10.8475V16.2266H12.025V15.0491L14.035 13.0391C15.5425 13.6241 17.305 13.3091 18.52 12.1016C20.1475 10.4741 20.155 7.83414 18.52 6.19914C16.8925 4.57164 14.245 4.57164 12.6175 6.19914C11.41 7.40664 11.1025 9.18414 11.68 10.6841L5.5375 16.8116L5.5 19.1366Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.4648 9.18359C16.9826 9.18359 17.4023 8.76386 17.4023 8.24609C17.4023 7.72833 16.9826 7.30859 16.4648 7.30859C15.9471 7.30859 15.5273 7.72833 15.5273 8.24609C15.5273 8.76386 15.9471 9.18359 16.4648 9.18359Z",
                fill: "currentColor"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconTransferSaham.tsx


function IconTransferSaham() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33382)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.625 8.14445L4.625 17.7345C4.625 18.469 5.22046 19.0645 5.955 19.0645H18.295C19.0295 19.0645 19.625 18.469 19.625 17.7345V8.14445C19.625 7.40991 19.0295 6.81445 18.295 6.81445H5.955C5.22046 6.81445 4.625 7.40991 4.625 8.14445Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.125 5.90195V6.81445H15.1175V5.90195C15.1175 5.16741 14.522 4.57195 13.7875 4.57195H10.455C9.72046 4.57195 9.125 5.16741 9.125 5.90195Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.375 11.8242C8.375 10.9992 9.05 10.3242 9.875 10.3242H15.875",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.375 8.82422L15.875 10.3242L14.375 11.8242",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.8301 14.0586C15.8301 14.8836 15.1551 15.5586 14.3301 15.5586H8.33008",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.83008 17.0586L8.33008 15.5586L9.83008 14.0586",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33382",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.125 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconTradingProfile.tsx


function IconTradingProfile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33397)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.875 19.5645C17.0171 19.5645 20.375 16.2066 20.375 12.0645C20.375 7.92232 17.0171 4.56445 12.875 4.56445C8.73286 4.56445 5.375 7.92232 5.375 12.0645C5.375 16.2066 8.73286 19.5645 12.875 19.5645Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.875 12.3711C14.1157 12.3711 15.125 11.3618 15.125 10.1211C15.125 8.88038 14.1157 7.87109 12.875 7.87109C11.6343 7.87109 10.625 8.88038 10.625 10.1211C10.625 11.3618 11.6343 12.3711 12.875 12.3711Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.66992 17.463C8.74992 15.723 10.6849 14.5605 12.8749 14.5605C15.0649 14.5605 16.9999 15.7155 18.0799 17.463",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33397",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.875 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconEStatement.tsx


function IconEStatement() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33375)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.375 18.2372C18.375 18.9718 17.7795 19.5672 17.045 19.5672H7.705C6.97046 19.5672 6.375 18.9718 6.375 18.2372V5.8925C6.375 5.15796 6.97046 4.5625 7.705 4.5625H13.0417L18.375 10.0745V18.2372Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.0396 10.0745H18.3729L13.0396 4.5625V10.0745Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33375",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.375 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconLiveSupport.tsx


function IconLiveSupport() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33412)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.41992 10.3145C6.78742 7.35195 9.31492 5.06445 12.3749 5.06445C14.0324 5.06445 15.5324 5.73945 16.6199 6.81945C17.5349 7.74195 18.1574 8.95695 18.3299 10.3145",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.875 18.3686C15.7244 17.8947 17.2331 16.5603 17.9397 14.8164",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.625 10.3145H7.125V14.8145H5.625C4.8 14.8145 4.125 14.1395 4.125 13.3145V11.8145C4.125 10.9895 4.8 10.3145 5.625 10.3145Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.125 14.8145H17.625V10.3145H19.125C19.95 10.3145 20.625 10.9895 20.625 11.8145V13.3145C20.625 14.1395 19.95 14.8145 19.125 14.8145Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.25 18.1895H13.5C13.7071 18.1895 13.875 18.3573 13.875 18.5645C13.875 18.7716 13.7071 18.9395 13.5 18.9395H11.25C11.0429 18.9395 10.875 18.7716 10.875 18.5645C10.875 18.3573 11.0429 18.1895 11.25 18.1895Z",
                        fill: "currentColor",
                        stroke: "currentColor",
                        strokeWidth: "1.5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33412",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.375 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/PopoverNavbarContainer/IconTradingLogout.tsx


function IconTradingLogout() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_674_33422)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.625 19.5645H6.875C6.4625 19.5645 6.125 19.227 6.125 18.8145V5.31445C6.125 4.90195 6.4625 4.56445 6.875 4.56445H13.625",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.625 12.0645H19.625",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.625 8.46484L19.625 12.0648L16.625 15.6648",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_674_33422",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(3.125 3.06445)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Mobile.tsx


























var subMenuList = realTadingMenu/* default.map */.Z.map(function(param) {
    var subMenu = param.subMenu;
    return subMenu;
}).flat();
var Mobile = function() {
    var router = (0,next_router.useRouter)();
    var openSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var ref = (0,useSecuritiesButton/* default */.Z)(), handleLogoutTrading = ref.handleLogoutTrading, handleClickSupportButton = ref.handleClickSupportButton;
    var handleBuyClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            openSearchCompanyModal();
        });
    };
    var handleClickMenu = function(data) {
        if (data.label === "Trading Logout") {
            handleLogoutTrading();
        }
        if (data.label === "Live Support") {
            handleClickSupportButton();
        }
    };
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-menu3_home":
                return "";
            case "icon-menu3_orderbook":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconOrderbook/* default */.Z, {});
            case "icon-menu3_portfolio":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPortfolio/* default */.Z, {});
            case "icon-menu3_order":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconOrder, {});
            case "icon-menu3_history":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHistory, {});
            case "icon-menu3_deposit":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDeposit, {});
            case "icon-menu3_withdraw":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWitdrawal, {});
            case "icon-securities-file":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEStatement, {});
            case "icon-briefcase_arrow":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTransferSaham, {});
            case "icon-menu3_account":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTradingProfile, {});
            case "icon-menu3_password":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSecurity, {});
            case "icon-menu3_support":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLiveSupport, {});
            case "icon-menu3_logout":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTradingLogout, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                size: "40px",
                                style: {
                                    marginRight: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/img/ssd.svg",
                                    alt: "logo-sekuritas",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Trading Area"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyButton, {
                        onClick: handleBuyClick,
                        children: "BUY"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Grid */.rj, {
                children: subMenuList.map(function(data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: data.label === "Stream" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NavigationMobile */.du, {
                            onClick: function() {
                                return handleClickMenu(data);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        color: data.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray
                                    },
                                    children: renderIcon(data.iconmoonMobile)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "a",
                                    size: "11px",
                                    align: "center",
                                    color: data.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray,
                                    children: data.label === "Stream" ? "" : data.label
                                })
                            ]
                        }, data.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.label === "Stream" ? "" : data.link,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NavigationMobile */.du, {
                                onClick: function() {
                                    return handleClickMenu(data);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            color: data.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray
                                        },
                                        children: renderIcon(data.iconmoonMobile)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "a",
                                        size: "11px",
                                        align: "center",
                                        color: data.matcher(router) ? color/* default.primary */.Z.primary : color/* default.dimgray */.Z.dimgray,
                                        children: data.label === "Stream" ? "" : data.label
                                    })
                                ]
                            }, data.label)
                        }, data.label)
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var RealTrading_Mobile = (Mobile);


/***/ }),

/***/ 38097:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SECURITIES_URL = "/securities";
var realTradingMenu = [
    {
        subMenu: [
            {
                label: "Orderbook",
                link: "/orderbook",
                iconmoonWeb: "icon-tradesmall_orderbook",
                iconmoonMobile: "icon-menu3_orderbook",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/orderbook")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Portfolio",
                link: "".concat(SECURITIES_URL, "/portfolio"),
                iconmoonWeb: "icon-tradesmall_portfolio",
                iconmoonMobile: "icon-menu3_portfolio",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/portfolio")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Order",
                link: "".concat(SECURITIES_URL, "/order"),
                iconmoonWeb: "icon-tradesmall_order",
                iconmoonMobile: "icon-menu3_order",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/order") && !asPath.includes("/orderbook")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "History",
                link: "".concat(SECURITIES_URL, "/history"),
                iconmoonWeb: "icon-tradesmall_history",
                iconmoonMobile: "icon-menu3_history",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/history")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    },
    {
        subMenu: [
            {
                label: "Deposit",
                link: "".concat(SECURITIES_URL, "/deposit"),
                iconmoonWeb: "icon-tradesmall_deposit",
                iconmoonMobile: "icon-menu3_deposit",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/deposit")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Withdrawal",
                link: "".concat(SECURITIES_URL, "/withdrawal"),
                iconmoonWeb: "icon-tradesmall_withdraw",
                iconmoonMobile: "icon-menu3_withdraw",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/withdrawal")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "E-Statement",
                link: "".concat(SECURITIES_URL, "/estatement"),
                iconmoonWeb: "icon-securities-file",
                iconmoonMobile: "icon-securities-file",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/estatement")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Transfer Saham",
                link: "".concat(SECURITIES_URL, "/stocktransfer"),
                iconmoonWeb: "icon-briefcase_arrow",
                iconmoonMobile: "icon-briefcase_arrow",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/stocktransfer")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    },
    {
        subMenu: [
            {
                label: "Trading Profile",
                link: "/profile/account/trading",
                iconmoonWeb: "icon-tradesmall_account",
                iconmoonMobile: "icon-menu3_account",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/profile/account/trading")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Security",
                link: "".concat(SECURITIES_URL, "/settings"),
                iconmoonWeb: "icon-securities-security",
                iconmoonMobile: "icon-menu3_password",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/settings")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    },
    {
        subMenu: [
            {
                label: "Live Support",
                link: "",
                iconmoonWeb: "icon-tradesmall_support",
                iconmoonMobile: "icon-menu3_support",
                matcher: function() {
                    return false;
                }
            },
            {
                label: "Trading Logout",
                link: "",
                iconmoonWeb: "icon-tradesmall_logout",
                iconmoonMobile: "icon-menu3_logout",
                matcher: function() {
                    return false;
                }
            },
            {
                label: "Stream",
                link: "/stream",
                iconmoonWeb: "icon-tradesmall_home",
                iconmoonMobile: "icon-menu3_home",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/stream")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (realTradingMenu);


/***/ }),

/***/ 39971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HE": function() { return /* binding */ ButtonBuyWrapper; },
/* harmony export */   "Kf": function() { return /* binding */ PopoverContainerBlock; },
/* harmony export */   "Rw": function() { return /* binding */ TradingMenuItemContainer; },
/* harmony export */   "_L": function() { return /* binding */ ButtonTrading; },
/* harmony export */   "_T": function() { return /* binding */ TradingMenuTitle; },
/* harmony export */   "b1": function() { return /* binding */ StockTransferNotif; },
/* harmony export */   "du": function() { return /* binding */ NavigationMobile; },
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "vG": function() { return /* binding */ TradeAreaContent; },
/* harmony export */   "yp": function() { return /* binding */ TextLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37944);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* eslint-disable no-confusing-arrow */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  flex-direction: ",
        ";\n\n  height: ",
        ";\n  cursor: pointer;\n\n  width: 100%;\n  min-width: 110px;\n  max-width: 145px;\n  padding: 16px;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: 0;\n    background: ",
        ";\n    z-index: 2;\n  }\n\n  img.arrow {\n    transform: ",
        ";\n    transition: transform 0.3s ease;\n    user-select: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 13px;\n  line-height: 18px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  user-select: none;\n\n  max-width: ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 15px;\n  line-height: 24px;\n  font-weight: bold;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  bakcground: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  height: 35px;\n  cursor: pointer;\n\n  :hover {\n    background: #f7f7f7;\n    border-radius: 4px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 8px 0;\n  min-width: 250px;\n  width: 100%;\n\n  .divider {\n    margin: 8px 0 0;\n    border-top: 1px solid #f1f1f1;\n  }\n\n  :last-child {\n    border-bottom: none;\n    padding-bottom: 8px;\n\n    .divider,\n    a:nth-child(3) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: flex;\n\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n\n  /* Remove scrollbar for Chrome, Safari and Opera */\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Remove scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-bottom-left-radius: 4px;\n\n  h1,\n  p,\n  span,\n  img {\n    user-select: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n\n  @media screen and (max-width: 762px) {\n    &:first-child {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #ecf8fd;\n  min-width: 250px;\n  width: 100%;\n\n  button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n\n    &.trading-menu-notification {\n      padding: 6px 0 6px 12px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      font-family: var(--bold-font);\n      text-align: left;\n      color: #333333;\n\n      p {\n        margin: 0;\n      }\n\n      img {\n        margin-right: 12px;\n        min-width: 38px;\n      }\n    }\n\n    &.trading-menu-notification-close {\n      padding: 0 12px;\n\n      img {\n        min-width: 10px;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  min-width: 250px;\n  border-bottom: 1px solid #f1f1f1;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}





var ButtonTrading = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-83e0c54d-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, function(param) {
    var isActive = param.isActive;
    return isActive ? "rotate(180deg)" : "rotate(0deg)";
});
var TextLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-83e0c54d-1"
})(_templateObject1(), function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "60px" : "100px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "4px" : "0";
});
var TradingMenuTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-83e0c54d-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var TradingMenuItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-83e0c54d-3"
})(_templateObject3());
var TradeAreaContent = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-83e0c54d-4"
})(_templateObject4());
var Grid = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-83e0c54d-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);
var PopoverContainerFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_header__WEBPACK_IMPORTED_MODULE_3__/* .PopoverContainer */ .OI).withConfig({
    componentId: "sc-83e0c54d-6"
})(_templateObject6());
var PopoverContainerBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(PopoverContainerFlex).withConfig({
    componentId: "sc-83e0c54d-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var NavigationMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-83e0c54d-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);
var StockTransferNotif = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-83e0c54d-9"
})(_templateObject9());
var ButtonBuyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-83e0c54d-10"
})(_templateObject10());



/***/ }),

/***/ 39809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ Search_Mobile; },
  "p": function() { return /* reexport */ Search_Web; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/Header/Search/slice.ts + 1 modules
var slice = __webpack_require__(59016);
// EXTERNAL MODULE: ./src/global/Header/Search/styled.ts
var styled = __webpack_require__(33591);
// EXTERNAL MODULE: ./src/global/Header/Search/options.tsx
var options = __webpack_require__(31706);
;// CONCATENATED MODULE: ./src/global/Header/Search/Mobile.jsx
// eslint-disable react-hooks/exhaustive-deps










var Mobile = function() {
    var ref = (0,react.useState)(false), isSearchBarVisible = ref[0], setVisibilitySearchBar = ref[1];
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), visible = ref2[0], setVisible = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,es/* useSelector */.v9)(slice/* selectors */.wl), result = ref3.result, recent = ref3.recent;
    var inputRef = (0,react.useRef)(null);
    var handleOutsideClick = function(e) {
        // In antd if we only use `inputRef` as input ref, it will point to
        // the **input component** instead of the HTML component
        // thus we use `inputRef.current.input` instead of `inputRef.current`
        if (inputRef.current && !inputRef.current.input.contains(e.target)) {
            setVisible(false);
        }
    };
    var debouncedSearch = lodash_debounce_default()(function(value) {
        return dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500);
    var handleSelect = lodash_debounce_default()(function() {
        return setKeyword("");
    }, 500);
    var onFocus = function() {
        setVisible(true);
        dispatch(slice/* effects.getSearchRecentResult */.Sz.getSearchRecentResult());
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Relative */.Ig, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "40px",
                onClick: function() {
                    return setVisibilitySearchBar(!isSearchBarVisible);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    size: "30px",
                    className: "icon-android_search"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SearchBarWrapper */.cI, {
                isVisible: isSearchBarVisible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                        options: keyword.length > 0 ? (0,options/* default */.ZP)(result) : (0,options/* recentOptions */.J4)(recent),
                        value: keyword,
                        onSelect: handleSelect,
                        open: visible,
                        onFocus: function() {
                            return setVisible(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            placeholder: "Search for brand, symbol or username...",
                            ref: inputRef,
                            height: "30px",
                            value: keyword,
                            onChange: function(e) {
                                var value = e.target.value;
                                setKeyword(value);
                                debouncedSearch(value);
                            },
                            onFocus: onFocus,
                            width: "100%",
                            "data-cy": "top-navbar-search-input-mobile"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* IconClose */.bM, {
                        size: "30px",
                        onClick: function() {
                            setVisibilitySearchBar(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            size: "15px",
                            className: "icon-compose_close"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Search_Mobile = (Mobile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/global/Header/Search/Web.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ 











var Web = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), result = ref.result, recent = ref.recent;
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), visible = ref2[0], setVisible = ref2[1];
    var ref3 = (0,react.useState)(false), isNavigating = ref3[0], setIsNavigating = ref3[1];
    var inputRef = (0,react.useRef)(null);
    var handleOutsideClick = function(e) {
        // In antd if we only use `inputRef` as input ref, it will point to
        // the **input component** instead of the HTML component
        // thus we use `inputRef.current.input` instead of `inputRef.current`
        if (inputRef.current && !inputRef.current.input.contains(e.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        setKeyword(value);
        debouncedSearch(value);
        setIsNavigating(false);
    };
    var onFocus = function() {
        setVisible(true);
        dispatch(slice/* effects.getSearchRecentResult */.Sz.getSearchRecentResult());
    };
    var resetSearchResult = function() {
        setKeyword("");
        setVisible(false);
        inputRef.current.blur();
    };
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_value, option) {
            var ref, ref1, data, url, isUser, ref2, ref3, ref4, ref5, ref6, id, url1, searchType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isNavigating) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        data = option.label.props;
                        url = (ref = option.label.props) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.url;
                        setIsNavigating(false);
                        setVisible(false);
                        isUser = data.searchType === "user";
                        if (!isUser) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 10;
                        return dispatch(slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: data.item.name,
                            target: data.item.id,
                            type: "people"
                        }));
                    case 10:
                        _ctx.next = 14;
                        break;
                    case 12:
                        _ctx.next = 14;
                        return dispatch(slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: data.item.symbol || data.item.symbol_2,
                            target: data.item.id,
                            type: "company"
                        }));
                    case 14:
                        router.push("/".concat(url));
                        resetSearchResult();
                        _ctx.next = 19;
                        break;
                    case 18:
                        {
                            ;
                            id = (ref2 = option.label.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.id;
                            url1 = (ref4 = option.label.props) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.item) === null || ref5 === void 0 ? void 0 : ref5.url;
                            searchType = (ref6 = option.label.props) === null || ref6 === void 0 ? void 0 : ref6.searchType;
                            if (url1) {
                                router.push("/".concat(url1));
                            }
                            // insider searchType have url === ''
                            if (searchType === "insider") {
                                router.push("/insider/".concat(id));
                            }
                            resetSearchResult();
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelect(_value, option) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1, val, search, _payload, error, data, _company, company, symbol, _people, user;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        val = "";
                        if (typeof e !== "string") {
                            val = e.target.value;
                        }
                        if (!(val.length === 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isNavigating) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        if (!(val.length <= 3)) {
                            _ctx.next = 10;
                            break;
                        }
                        router.push("/search?q=".concat(val));
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(val));
                    case 12:
                        search = _ctx.sent;
                        _payload = search.payload, error = _payload.error, data = _payload.data;
                        if (!error) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 16:
                        if (!(val.length < 10 && ((ref = data.company) === null || ref === void 0 ? void 0 : ref.length) > 0)) {
                            _ctx.next = 24;
                            break;
                        }
                        _company = (0,_sliced_to_array/* default */.Z)(data.company, 1), company = _company[0];
                        symbol = company.name || company.symbol_2;
                        _ctx.next = 21;
                        return dispatch(slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: val,
                            target: company.id,
                            type: "company"
                        }));
                    case 21:
                        resetSearchResult();
                        router.push("/symbol/".concat(symbol));
                        return _ctx.abrupt("return");
                    case 24:
                        if (!(val.length > 4 && ((ref1 = data.people) === null || ref1 === void 0 ? void 0 : ref1.length) === 1)) {
                            _ctx.next = 30;
                            break;
                        }
                        _people = (0,_sliced_to_array/* default */.Z)(data.people, 1), user = _people[0];
                        _ctx.next = 28;
                        return dispatch(slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: val,
                            target: user.id,
                            type: "people"
                        }));
                    case 28:
                        router.push("/".concat(user.name));
                        return _ctx.abrupt("return");
                    case 30:
                        // catch, redirect to search page
                        router.push("/search?q=".concat(val));
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePressEnter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleListenArrowKey = function(e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            setIsNavigating(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        autoComplete: "off",
        onSubmit: function(e) {
            return e.preventDefault();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Autocomplete */.F2, {
            options: keyword.length > 0 ? (0,options/* default */.ZP)(result) : (0,options/* recentOptions */.J4)(recent),
            width: "320px",
            getPopupContainer: function(trigger) {
                return trigger.parentElement;
            },
            value: keyword,
            onSelect: handleSelect,
            open: visible,
            onFocus: function() {
                return setVisible(true);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                placeholder: "Search for brand, symbol or username...",
                height: "30px",
                ref: inputRef,
                value: keyword,
                onChange: onChange,
                onFocus: onFocus,
                // @ts-expect-error
                onPressEnter: handlePressEnter,
                width: "100%",
                onKeyDown: handleListenArrowKey,
                "data-cy": "top-navbar-search-input-desktop"
            })
        })
    });
};
/* harmony default export */ var Search_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/Search/index.jsx




/***/ }),

/***/ 31706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J4": function() { return /* binding */ recentOptions; },
/* harmony export */   "zU": function() { return /* binding */ CustomAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12484);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37213);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42227);
/* harmony import */ var global_Labels__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94493);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2497);
/* harmony import */ var features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63576);
/* harmony import */ var global_TradingModal_RealTradingModal_ModalBonds_useBondsAnalytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29735);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33591);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(59016);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 

















var Tag = _deprecated_ui_common_Tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Tag */ .Z.Tag;
var CustomAvatar = function(param) {
    var img = param.img, name = param.name;
    var url = img.match(/http/g) ? img : "".concat(constants_api__WEBPACK_IMPORTED_MODULE_7__/* .AVATAR_URL */ .q$, "/").concat(img);
    if (!img) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        size: "x-small",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            alt: name,
            src: url,
            onError: function(e) {
                (0,utils_general__WEBPACK_IMPORTED_MODULE_11__/* .handleErrorAvatar */ .Tk)(e, name);
            }
        })
    });
};
CustomAvatar.propTypes = {
    name: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string.isRequired),
    img: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string.isRequired)
};
var LabelComponent = function(param) {
    var item = param.item, searchType = param.searchType;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_13__/* .useDispatch */ .I0)();
    var FRBondActionTrackers = (0,global_TradingModal_RealTradingModal_ModalBonds_useBondsAnalytics__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)().FRBondActionTrackers;
    var postSearchRecent = function(keyword, target, type) {
        return dispatch(_slice__WEBPACK_IMPORTED_MODULE_17__/* .effects.postSearchRecentResult */ .Sz.postSearchRecentResult({
            keyword: keyword,
            target: target,
            type: type
        }));
    };
    if (searchType === "sector") {
        var url = item.parent_alias1 ? "".concat(item.parent_alias1, "/").concat(item.name) : item.name;
        var eventClick = item.alias1 === "fr-bonds" ? function() {
            return FRBondActionTrackers.onFRProductListClicked("Search Page");
        } : null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
            href: "/catalog/".concat(url),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_16__/* .CatalogItem */ .me, {
                onClick: eventClick,
                children: item.name
            })
        });
    }
    if (searchType === "user") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_16__/* .NavLink */ .OL, {
            onClick: function() {
                postSearchRecent(item.name, item.id, "people");
                features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_14__/* .mainProfileEvents.onViewProfile */ .j4.onViewProfile(features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_14__/* .PAGE_SOURCE.search */ .nP.search);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAvatar, {
                    img: item.img,
                    name: item.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    direction: "column",
                    pl: "10px",
                    style: {
                        gap: "2px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            align: "center",
                            style: {
                                gap: "2px"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    size: "14px",
                                    mt: "2px",
                                    family: "bold",
                                    children: item.keyword || item.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Labels__WEBPACK_IMPORTED_MODULE_12__/* .LabelVerifiedAccount */ .uC, {
                                    deprecatedVerifiedStatus: item.is_verified
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: "12px",
                            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray,
                            children: item.desc || item.name
                        })
                    ]
                })
            ]
        });
    }
    if (searchType === "insider") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_16__/* .NavLink */ .OL, {
            onClick: function() {
                return postSearchRecent(item.label, item.id, "insider");
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        src: "/icon/icon-bandar.svg"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    pl: "10px",
                    size: "13px",
                    children: item.label
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_16__/* .NavLink */ .OL, {
        onClick: function() {
            return postSearchRecent(item.name, item.id, "company");
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
                size: "xs",
                type: "grey",
                style: {
                    fontFamily: "ProximaNovaBd"
                },
                children: item.keyword || item.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                pl: "10px",
                size: "13px",
                children: item.desc || item.name
            })
        ]
    });
};
var renderLabel = function(item) {
    var catalogKey = "_type";
    var type = item.type ? item.type : item[catalogKey];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelComponent, {
        item: item,
        searchType: String(type).toLowerCase()
    });
};
var recentOptions = function(suggestions) {
    if (!suggestions.list) {
        return [];
    }
    if (suggestions.list.length === 0) {
        return [];
    }
    return [
        {
            label: "Recent Searches",
            options: suggestions.list.map(function(item) {
                return {
                    value: "suggestion-".concat(item.id, "-").concat(item.keyword),
                    label: renderLabel(item)
                };
            })
        }, 
    ];
};
var options = function(suggestions) {
    if (!suggestions) {
        return [];
    }
    var company = suggestions.company.length > 0 ? {
        label: "Stocks",
        options: suggestions.company.map(function(item) {
            return {
                value: "stock-".concat(item.id, "-").concat(item.keyword || item.name),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var people = suggestions.people.length > 0 ? {
        label: "People",
        options: suggestions.people.map(function(item) {
            return {
                value: "people-".concat(item.id, "-").concat(item.name),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var insider = suggestions.insider.length > 0 ? {
        label: "Insider",
        options: suggestions.insider.map(function(item) {
            return {
                value: "insider-".concat(item.id),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var catalog = suggestions.sector.length > 0 ? {
        label: "Catalog",
        options: [
            {
                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    wrap: "wrap",
                    style: {
                        gap: "10px"
                    },
                    children: suggestions.sector.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LabelComponent, {
                            item: item,
                            searchType: "sector"
                        });
                    })
                }),
                value: "catalog-sector",
                className: "catalog-res"
            }, 
        ]
    } : undefined;
    var list = [
        catalog,
        company,
        people,
        insider
    ];
    return list.filter(function(item) {
        return item !== undefined;
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (options);


/***/ }),

/***/ 59016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/search/index.js

var schema = {
    company: [],
    sector: [],
    insider: [],
    chat: [],
    user_more: 0,
    company_more: 0,
    people: []
};
var propTypesPeople = (0,prop_types.shape)({
    id: prop_types.number,
    img: prop_types.string,
    followed: prop_types.number,
    official: prop_types.number,
    name: prop_types.string,
    desc: prop_types.string,
    url: prop_types.string,
    type: prop_types.string,
    other: prop_types.string,
    total_followers: prop_types.number
});
var propTypes = {
    company: (0,prop_types.arrayOf)(prop_types.object),
    sector: (0,prop_types.arrayOf)(prop_types.object),
    insider: (0,prop_types.arrayOf)(prop_types.object),
    chat: (0,prop_types.arrayOf)(prop_types.object),
    user_more: prop_types.number,
    company_more: prop_types.number,
    people: (0,prop_types.arrayOf)(propTypesPeople)
};
/* harmony default export */ var models_search = ({
    schema: schema,
    propTypes: propTypes,
    propTypesPeople: propTypesPeople
});

;// CONCATENATED MODULE: ./src/global/Header/Search/slice.ts







// Action type
var CONTEXT = "@global/search";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT"),
    POST_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/POST_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: schema,
    recent: {
        list: []
    }
};
// Selectors
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.search;
}, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result,
        recent: state.recent
    };
});
// Effects
var effects = {
    getSearchResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearch */.Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RECENT_RESULT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return search/* default.getSearchRecent */.Z.getSearchRecent();
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }))),
    postSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_SEARCH_RECENT_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var keyword, target, type, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, target = param.target, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.postSearchRecent */.Z.postSearchRecent(keyword, target, type);
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            result: action.payload.data
        });
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.getSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchRecentResult.fulfilled, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            recent: {
                list: action.payload.data
            }
        });
    }).addCase(effects.getSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.postSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.postSearchRecentResult.fulfilled, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false
        });
    }).addCase(effects.postSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            error: action.payload
        });
    });
};
// Slice
var searchSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "search",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (searchSlice);


/***/ }),

/***/ 33591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ Autocomplete; },
/* harmony export */   "Ig": function() { return /* binding */ Relative; },
/* harmony export */   "OL": function() { return /* binding */ NavLink; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "cI": function() { return /* binding */ SearchBarWrapper; },
/* harmony export */   "me": function() { return /* binding */ CatalogItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94526);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 999px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  display: inline-flex;\n  font-size: 12.5px;\n\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* .rc-virtual-list-holder-inner {\n    flex-direction: row;\n    flex-wrap: wrap;\n  } */\n\n  .ant-select-item-option-grouped {\n    padding-left: 12px;\n  }\n\n  .ant-select-item-group {\n    &:not(:first-child) {\n      border-top: dashed 1px ",
        ";\n    }\n\n    border-bottom: solid 1px #f0f0f0;\n    font-size: 14px;\n    color: ",
        ";\n    width: 100%;\n  }\n\n  .ant-select-item-option {\n    width: 100%;\n    align-items: center;\n  }\n\n  .catalog-res {\n    background: #fff;\n    padding: 12px;\n\n    &:hover,\n    &:focus {\n      background: #fff;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var Relative = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-88140-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var CatalogItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    size: "13px",
    p: "2px 8px"
}).withConfig({
    componentId: "sc-88140-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var SearchBarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-88140-2"
})(_templateObject2(), function(props) {
    // @ts-expect-error
    return ((props === null || props === void 0 ? void 0 : props.isVisible) ? "flex" : "none");
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var IconClose = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a).withConfig({
    componentId: "sc-88140-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lowgray */ .Z.lowgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var Autocomplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Autocomplete__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-88140-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray);
var NavLink = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-88140-5"
})(_templateObject5());



/***/ }),

/***/ 80567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchCompanyModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Header/SearchCompanyModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  background: ",
        ";\n  z-index: 99999;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 600px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #33bc89;\n  color: ",
        ";\n  height: 40px;\n  width: 100px;\n  border: 2px solid #33bc89;\n  border-radius: 3px;\n  transition: opacity 0s !important;\n  font-size: 16px;\n\n  &:hover {\n    background-color: #00ab6b;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  &:hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var FullScreenContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6cba26ee-0"
})(_templateObject(), color/* default.light */.Z.light);
var SearchCompanyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6cba26ee-1"
})(_templateObject1());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-6cba26ee-2"
})(_templateObject2(), color/* default.light */.Z.light, color/* default.light */.Z.light);
var styled_Iconmoon = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).withConfig({
    componentId: "sc-6cba26ee-3"
})(_templateObject3());


;// CONCATENATED MODULE: ./src/global/Header/SearchCompanyModal/index.tsx















function SearchCompanySymbol(param) {
    var onSymbolChange = param.onSymbolChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    var result = (0,es/* useSelector */.v9)(slice/* selectors */.wl).result;
    var stockInputRef = (0,react.useRef)();
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var openBondsBuy = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var closeSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.closeModal;
    });
    var isSuggestionEmpty = !(result === null || result === void 0 ? void 0 : result.length) || (result === null || result === void 0 ? void 0 : result.length) < 1;
    var onClose = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
                        closeSearchCompanyModal();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClose() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenTransaction = function(symbol, type) {
        if (type === "fr") {
            openBondsBuy(symbol);
            FRBondActionTrackers.onOrderButtonClicked("Buy", symbol, "Search Company Page");
        } else {
            onSymbolChange(symbol);
        }
        onClose();
    };
    var handleConfirm = function() {
        if (isSuggestionEmpty) {
            return;
        }
        var _result = (0,_sliced_to_array/* default */.Z)(result, 1), selected = _result[0];
        if (!selected) {
            return;
        }
        handleOpenTransaction(selected.name, selected.type);
    };
    var onClickResult = function(symbol) {
        if (isSuggestionEmpty) {
            return;
        }
        var item = result.find(function(el) {
            return el.name === symbol;
        });
        if (!item) {
            return;
        }
        handleOpenTransaction(item.name, item.type);
    };
    (0,react.useEffect)(function() {
        var ref;
        (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchCompanyWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "26px",
                            color: color/* default.primary */.Z.primary,
                            children: "Type symbol to buy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Iconmoon, {
                            size: "16px",
                            color: color/* default.nightRider */.Z.nightRider,
                            className: "icon-trading_xbold",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                    ref: stockInputRef,
                    isInTradingModal: false,
                    updateSymbol: onClickResult
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    justify: "flex-end",
                    padding: "10px",
                    mt: "5px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            padding: "10px",
                            color: color/* default.nobel */.Z.nobel,
                            children: "Press Enter or"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                            disabled: isSuggestionEmpty,
                            onClick: handleConfirm,
                            children: "CONFIRM"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var SearchCompanyModal = (SearchCompanySymbol);


/***/ }),

/***/ 13263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(579);
/* harmony import */ var features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70175);
/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71158);
/* harmony import */ var global_Securities_stores_useSearchCompanyModalStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5612);
/* harmony import */ var _virtualTradingMenu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66980);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39035);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46990);















var VirtualTradeMobile = function() {
    var showAuthModal = (0,features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.showModal;
    });
    var showSearchCompanyModal = (0,global_Securities_stores_useSearchCompanyModalStore__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(s) {
        return s.showModal;
    });
    var handleSwitchReal = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_9__/* ["default"].getState */ .Z.getState().loadLogout();
                    case 2:
                        showAuthModal();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSwitchReal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        style: {
            padding: "16px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_5__/* .IconWrapper */ .a, {
                        size: "40px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            src: "/icon/favicon.ico"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: "Virtual Area"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "primary",
                margin: "10px 0",
                height: "36px",
                block: true,
                onClick: showSearchCompanyModal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: "14px",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light,
                    align: "center",
                    children: "BUY"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .Grid */ .rj, {
                children: _virtualTradingMenu__WEBPACK_IMPORTED_MODULE_11__/* ["default"][0].subMenu.map */ .Z[0].subMenu.map(function(subMenu) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .NavigationMobile */ .du, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: subMenu.iconmoonMobile,
                                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].dimgray */ .Z.dimgray,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                as: "a",
                                size: "11px",
                                align: "center",
                                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].dimgray */ .Z.dimgray,
                                children: subMenu.label
                            })
                        ]
                    }, subMenu.label);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    padding: "0px 16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .SwitchButton */ .U3, {
                    height: "32px",
                    onClick: handleSwitchReal,
                    block: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary,
                        size: "14px",
                        padding: "0 8px",
                        children: "Switch to Real Account"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VirtualTradeMobile);


/***/ }),

/***/ 39035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kf": function() { return /* binding */ PopoverContainerBlock; },
/* harmony export */   "Rw": function() { return /* binding */ TradingMenuItemContainer; },
/* harmony export */   "_L": function() { return /* binding */ ButtonTrading; },
/* harmony export */   "_T": function() { return /* binding */ TradingMenuTitle; },
/* harmony export */   "du": function() { return /* binding */ NavigationMobile; },
/* harmony export */   "rj": function() { return /* binding */ Grid; },
/* harmony export */   "vG": function() { return /* binding */ TradeAreaContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37944);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  flex-direction: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: ",
        ";\n    background: ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 15px;\n  line-height: 24px;\n  font-weight: 700;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 0 15px;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n    p,\n    p::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 6px;\n  width: 250px;\n  background-color: white;\n  padding: 10px 0;\n  border-bottom: 1px solid ",
        ";\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: flex;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var ButtonTrading = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-48b1915d-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "16px 0" : "0 16px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "110px" : "145px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? "1px" : 0;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);
var TradingMenuTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-48b1915d-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var TradingMenuItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-48b1915d-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var TradeAreaContent = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-48b1915d-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lowgray */ .Z.lowgray);
var Grid = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-48b1915d-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);
var PopoverContainerFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_header__WEBPACK_IMPORTED_MODULE_3__/* .PopoverContainer */ .OI).withConfig({
    componentId: "sc-48b1915d-5"
})(_templateObject5());
var PopoverContainerBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(PopoverContainerFlex).withConfig({
    componentId: "sc-48b1915d-6"
})(_templateObject6());
var NavigationMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-48b1915d-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);



/***/ }),

/***/ 66980:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var virtualTradingMenu = [
    {
        title: "Trading",
        subMenu: [
            {
                label: "Orderbook",
                link: "/orderbook",
                iconmoonWeb: "icon-tradesmall_orderbook",
                iconmoonMobile: "icon-menu3_orderbook"
            },
            {
                label: "Portfolio",
                link: "/trade/portfolio",
                iconmoonWeb: "icon-tradesmall_portfolio",
                iconmoonMobile: "icon-menu3_portfolio"
            },
            {
                label: "Order",
                link: "/trade/order",
                iconmoonWeb: "icon-tradesmall_order",
                iconmoonMobile: "icon-menu3_order"
            }, 
        ]
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (virtualTradingMenu);


/***/ }),

/***/ 46990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ HeaderMobile; },
/* harmony export */   "U3": function() { return /* binding */ SwitchButton; },
/* harmony export */   "cA": function() { return /* binding */ ProUser; },
/* harmony export */   "q8": function() { return /* binding */ HeaderWeb; },
/* harmony export */   "xn": function() { return /* binding */ HeaderWebTop; }
/* harmony export */ });
/* unused harmony export Fixed */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: scroll;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 16px;\n  border-bottom: 1px solid ",
        ";\n  background: ",
        ";\n  z-index: 100;\n\n  &.chat-expanded {\n    display: none;\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  width: ",
        ";\n\n  &.chat-expanded {\n    display: none;\n  }\n\n  @media ",
        " {\n    position: fixed;\n    display: flex;\n    justify-content: space-between;\n    top: 0;\n    left: 0;\n    right: 0;\n    border-bottom: 1px solid ",
        ";\n    background: white;\n    z-index: 102;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 24px;\n  padding-right: 14px;\n  height: 60px;\n  z-index: 100;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  border: 1px solid #DADADA;\n  padding: 4px 8px;\n  border-radius: 3px;\n  text-wrap: nowrap;\n  white-space: pre;\n  margin-right: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    background: ",
        ";\n    p {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var Fixed = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4c205530-0"
})(_templateObject());
var HeaderMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4c205530-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var HeaderWeb = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4c205530-2"
})(_templateObject2(), function(param) {
    var isOpen = param.isOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isOpen) {
            return "calc(100% - 48px)";
        }
        if (!isMarketOpen) {
            return "calc(100% - 438px)";
        }
        return "calc(100% - 378px)";
    }();
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var HeaderWebTop = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4c205530-3"
})(_templateObject3());
var ProUser = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-4c205530-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var SwitchButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4c205530-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);



/***/ }),

/***/ 7162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LabelBroadcast; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #796fec;\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  width: 12px;\n  height: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconFrame = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3ac81157-0"
})(_templateObject());
function LabelBroadcast() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconFrame, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/broadcast.svg",
            width: "8px",
            height: "8px",
            alt: "icon-broadcast"
        })
    });
};


/***/ }),

/***/ 5612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useSearchCompanyModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        showModal: function() {
            set({
                visible: true
            });
        },
        closeModal: function() {
            set({
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useSearchCompanyModalStore);


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondsAnalytics; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);



var EVENTS_NAMES = {
    bondsPageViewed: "FR Bonds Page Viewed",
    bondProductPageViewed: "FR Bonds Product Page Viewed",
    bondOrderPageViewed: "FR Bonds Order Page Viewed",
    bondPreviewOrderViewed: "FR Bonds Preview Order Viewed",
    bondOrderSuccessViewed: "FR Bonds Order Success Viewed",
    bondsAction: "FR Bonds Action"
};
var PAGE_NAMES = {
    "/stream": "Stream Page",
    "/symbol": "Product Page",
    "/securities": "Portofolio List",
    "/watchlist": "Watchlist Page",
    "/screener": "Screener Page",
    "/valuation": "Valuation Page",
    "/sector": "Sector Page",
    "/community": "Community Page"
};
function useBondsAnalytics() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // fill the search related page
    var defaultPageSource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var pageNames = Object.keys(PAGE_NAMES);
        var pageIndex = pageNames.find(function(path) {
            return router.pathname.startsWith(path) ? path : undefined;
        });
        if (pageIndex) {
            return PAGE_NAMES[pageIndex];
        }
        return "Search Page";
    }, [
        router.pathname
    ]);
    var FRBondsNavigateTrackers = {
        // When user landing on FR Bonds page
        onBondPageViewed: function onBondPageViewed(section) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsPageViewed, {
                Section: section
            });
        },
        // When user landing on FR Bonds Product page
        onBondProductPageViewed: function onBondProductPageViewed(symbol, yieldValue) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondProductPageViewed, {
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order page
        onBondOrderPageViewed: function onBondOrderPageViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderPageViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Preview Order page
        onBondPreviewOrderViewed: function onBondPreviewOrderViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondPreviewOrderViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order Success page
        onBondOrderSuccessViewed: function onBondOrderSuccessViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderSuccessViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    var FRBondActionTrackers = {
        // When user click FR Bonds introduction banner
        onIntroductionBannerClicked: function onIntroductionBannerClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "Introduction Banner Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click “Saya Setuju” on FR Bonds TnC
        onTnCConfirmed: function onTnCConfirmed() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "TnC Confirmed"
            });
        },
        // When user click FR Bonds Section/Catalog to be redirected to FR Bonds list
        onFRProductListClicked: function onFRProductListClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Product List Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click buy/sell button on FR product to initiate order
        onOrderButtonClicked: function onOrderButtonClicked(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Button Clicked",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page to finalize order
        onOrderPlaced: function onOrderPlaced(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Placed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page, confirming the order
        onOrderConfirmed: function onOrderConfirmed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Confirmed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    return {
        FRBondsNavigateTrackers: FRBondsNavigateTrackers,
        FRBondActionTrackers: FRBondActionTrackers
    };
};


/***/ }),

/***/ 77017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SearchCompany; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 99999 !important;\n  .rc-virtual-list-holder-inner > :first-child {\n    display: none !important;\n  }\n\n  .ant-select-dropdown {\n    width: 60% !important;\n    top: -55px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus {\n    border-right-width: 0px !important;\n  }\n  &:hover {\n    border-right-width: 0px !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  right: 60px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-0"
})(_templateObject(), color/* default.light */.Z.light);
var CatalogItem = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "13px",
    p: "3px 5px"
}).withConfig({
    componentId: "sc-1b956054-1"
})(_templateObject1(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var SearchBarWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1b956054-2"
})(_templateObject2(), // @ts-expect-error
function(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    return isVisible ? "flex" : "none";
}, color/* default.light */.Z.light);
var IconClose = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1b956054-3"
})(_templateObject3(), color/* default.lowgray */.Z.lowgray, color/* default.light */.Z.light);
var styled_Autocomplete = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.Z).withConfig({
    componentId: "sc-1b956054-4"
})(_templateObject4());
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-1b956054-5"
})(_templateObject5());
var IconmoonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-6"
})(_templateObject6());


;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 













var SearchCompany_Tag = Tag/* default.Tag */.Z.Tag;
var checkIsBonds = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.indexOf("FR") >= 0;
};
var SearchCompany = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var updateSymbol = param.updateSymbol, isInTradingModal = param.isInTradingModal, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds;
    var dispatch = (0,es/* useDispatch */.I0)();
    var _$ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), searchResult = _$ref.result;
    var result = isBonds ? searchResult === null || searchResult === void 0 ? void 0 : searchResult.filter(function(item) {
        return checkIsBonds(item === null || item === void 0 ? void 0 : item.desc);
    }) : searchResult;
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        debouncedSearch(value);
    };
    var onSelect = function(name, isSelectedBonds) {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
        updateSymbol(name, isSelectedBonds);
    };
    var onPressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _result, item;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (result) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _result = (0,_sliced_to_array/* default */.Z)(result, 1), item = _result[0];
                        if (item) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isBonds) {
                            _ctx.next = 8;
                            break;
                        }
                        updateSymbol(item.name, isBonds);
                        return _ctx.abrupt("return");
                    case 8:
                        updateSymbol(item.name, checkIsBonds(item.desc));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPressEnter() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderLabel = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return onSelect(item.name, checkIsBonds(item.desc));
            },
            "aria-hidden": true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany_Tag, {
                        size: "xs",
                        type: "grey",
                        children: item.keyword || item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        pl: "10px",
                        size: "13px",
                        children: item.desc || item.name
                    })
                ]
            })
        });
    };
    var options = function(suggestions) {
        if (!suggestions) {
            return [];
        }
        var company = suggestions.length > 0 ? {
            options: suggestions.map(function(item) {
                return {
                    value: item.keyword || item.name,
                    label: renderLabel(item)
                };
            })
        } : undefined;
        var list = [
            company
        ];
        return list.filter(function(item) {
            return item !== undefined;
        });
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Autocomplete, {
        options: options(result),
        width: "100%",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        children: [
            isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                // @ts-expect-error
                ref: ref,
                placeholder: "Type company symbol here",
                height: "40px",
                onChange: onChange,
                width: "100%",
                loading: true,
                onPressEnter: onPressEnter,
                style: {
                    maxWidth: "460px"
                },
                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_SEARCH_COMPANY */.eG.HEADER_SEARCH_COMPANY
            }),
            !isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                // @ts-expect-error
                ref: ref,
                placeholder: "",
                height: "60px",
                onChange: onChange,
                width: "100%",
                onPressEnter: onPressEnter,
                style: {
                    outline: 0,
                    fontSize: "26px",
                    padding: "0px",
                    borderWidth: "0 0 2px"
                }
            })
        ]
    });
});
/* harmony default export */ var components_SearchCompany = (SearchCompany);


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);




// Action type
var CONTEXT = "@global/searchCompany";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: []
};
var searchCompanyState = function(state) {
    return state.searchCompany;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(searchCompanyState, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result
    };
}, function(state) {
    return state;
});
// Effects
var effects = {
    getSearchResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearch */ .Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    resetResult: function(state) {
        state.result = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state, action) {
        state.isLoading = true;
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref, ref1;
        state.result = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.company;
        state.isLoading = false;
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    });
};
// Slice
var searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "searchCompany",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (searchSlice);


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 85557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);

var useDownloadDesktopApp = function() {
    var getUrl = function(os) {
        return "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .DESKTOP_APP_UPDATER_URL */ .EU, "/").concat(os, "?format=bundle");
    };
    var download = function(os) {
        return window.open(getUrl(os), "_blank");
    };
    return {
        download: download,
        getUrl: getUrl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDownloadDesktopApp);


/***/ }),

/***/ 10200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Convert time based on format passed down
 * @param {
 *   Object {
 *     datetime: string,
 *     zone: string,
 *     oldFormat: string,
 *     newFormat: string
 *   }
 * } props - properties for moment.js
 * @returns
 */ function timeZoneConvert(param) {
    var datetime = param.datetime, zone = param.zone, oldFormat = param.oldFormat, newFormat = param.newFormat;
    var format = newFormat;
    if (!newFormat) {
        format = oldFormat;
    }
    var datetimeUtc = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(datetime, oldFormat).utc().format();
    if (!moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(datetimeUtc).isValid()) {
        return datetime;
    }
    return moment_timezone__WEBPACK_IMPORTED_MODULE_0___default().tz(datetimeUtc, zone).format(format);
}
/**
 * Get time zone string that is consumed by moment.js function
 * @param {string} country
 * @returns {string}
 */ function getAreaTimeZone(country) {
    var zone = "";
    switch(country){
        case "ID":
            zone = "Asia/Jakarta";
            break;
        case "MY":
            zone = "Asia/Kuala_Lumpur";
            break;
        case "SG":
            zone = "Asia/Singapore";
            break;
        default:
            zone = "Asia/Jakarta";
            break;
    }
    // return 'Africa/Cairo'
    return zone;
}
/**
 * Convert time using moment.js
 * @param {string} datetime
 * @param {string=} country
 * @param {string=} newformat
 * @param {string=} oldformat
 * @returns {string}
 */ function convertTimeZone(datetime, country, newformat, oldformat) {
    var newFormat = "DD MMM YY, HH:mm";
    var oldFormat = "YYYY-MM-DD HH:mm:ss";
    if (newformat) {
        newFormat = newformat;
    }
    if (oldFormat) {
        oldFormat = oldformat;
    }
    var zone = getAreaTimeZone(country);
    var lastMessageDate = timeZoneConvert({
        datetime: datetime,
        zone: zone,
        oldFormat: oldFormat,
        newFormat: newFormat
    });
    return moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(lastMessageDate).isValid() ? lastMessageDate : datetime;
}
/* harmony default export */ __webpack_exports__["Z"] = (convertTimeZone);


/***/ }),

/***/ 60374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ shallow; }
/* harmony export */ });
function shallow(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}




/***/ })

}]);